// 服务端提供的路径
const path = {
  /** *************通用路径 ***********************************************/
  getApplicationList: 'application/getApplications', // 获取应用列表
  getAllModule: 'module/findModuleList', // 获取模块列表
  getFindModuleListByAuth: 'module/findModuleListByAuth', // 用于新版查询模块列表
  getAppAllModuleList: 'module/findAllModule', // 获取跨应用模块列表
  getAllFieldList: 'layout/getFieldsByModule', // 获取所有字段
  queryBeanField: 'module/queryBeanField', // 获取所有字段（多个模块获取）
  getModuleRelations: 'layout/getModuleRelations', // 获取关联模块列表
  getModuleRefFields: 'layout/getModuleRefFields', // 获取当前模块关联关系字段
  getFieldsBySubform: 'layout/getFieldsBySubform', // 获取子表单
  getFieldsByNotSubform: 'layout/getFieldsByNotSubform', // 获取非子表单
  getFunAuthList: 'moduleDataAuth/getFuncAuthByModule', // 获取功能权限
  getDynmicList: 'common/queryDynamicList', // 获取动态列表
  getPicklistField: 'layout/getModuleRadioFields', // 获取模块下拉列表字段
  queryDepartmentLevel: 'employee/queryDepartmentLevel', // 获取公式层级列表
  getModuleList: 'report/getModuleList', // 获取所有模块列表
  getAppDetail: 'application/queryApplicationById', // 获取应用详情
  commonUpload: 'common/file/upload', // 公用上传文件
  customUpload: 'common/file/applyFileUpload', // 自定义上传文件
  getAccidentCarInfo: 'accident/getAccidentCarInfo', // AI图文识别-事故车信息识别
  centerUploadImage: 'common/center/upload/image', // 应用中心上传
  findPcAllModuleList: 'module/findPcAllModuleList', // 获取所有模块列表(2.0导航)
  getTemplateModuleByTemplateId: 'module/getTemplateModuleByTemplateId', // 根据模板应用ID获取模板模块
  getAuthByBean: 'moduleDataAuth/getAuthByBean', // 获取权限
  queryDepartment: 'common/queryDepartment', // 获取权限
  getReferenceFields: 'layout/getReferenceFields', // 获取关联模块字段
  findRelationById: 'relation/findRelationById', // 获取关联引用详情接口
  searchModules: 'module/findModules', // 搜索基础模块和应用模块

  /** **********END******************************************************/

  /** ************************页签管理 START*******************************/
  tabFindList: 'tab/findList', // 页签列表
  tabFindModuleList: 'tab/findModuleList', // 获取所有应用及模块
  tabFindFieldsList: 'tab/findFieldsList', // 获取目标及源模块字段
  tabStick: 'tab/stick', // 置顶
  tabSave: 'tab/save', // 新增
  tabUpdate: 'tab/update', // 编辑
  tabDel: 'tab/del', // 删除
  tabFindDetail: 'tab/findDetail', // 获取详情
  /** ************************页签管理 END*******************************/

  /** ************************接口集成 START*******************************/
  recruitmentWebsiteFindAll: 'recruitmentWebsite/findAll', // 招聘网站列表
  recruitmentWebsiteUpdateStatus: 'recruitmentWebsite/updateStatus', // 招聘网站编辑
  getDataListFieldsForRecruitmentWebsite: 'layout/getDataListFieldsForRecruitmentWebsite', // 获取简历模块的所有字段
  recruitmentWebsiteGetLayout: 'recruitmentWebsite/getLayout', // 根据id获取详情
  recruitmentWebsiteSave: 'recruitmentWebsite/save', // 新增
  recruitmentWebsiteUpdate: 'recruitmentWebsite/update', // 编辑
  recruitmentWebsiteDownload: 'common/file/recruitmentWebsiteDownload', // 下载简历分析插件
  // recruitmentWebsiteDownload: 'commonFile/recruitmentWebsiteDownload', // 下载简历分析插件
  getRecognitionFieldForRecruitmentWebsite: 'layout/getRecognitionFieldForRecruitmentWebsite', // 获取简历识别字段
  findIntegrationApplications: 'module/findApplications', // 获取应用列表数据
  findIntegrationModules: 'module/findModules', // 获取模块列表数据
  getIntegrationParamDetail: 'module/getParamDetail', // 获取接口参数详情
  thirdpartyRestToken: 'thirdparty/restToken', // 重置token
  thirdpartyGetToken: 'thirdparty/getToken', // 获取三方token
  thirdpartySaveUser: 'thirdparty/saveUser', // 添加平台
  thirdpartyDelUser: 'thirdparty/delUser', // 删除平台
  thirdpartyFindUsersList: 'thirdparty/findUsersList', // 平台列表
  thirdpartySaveSetting: 'thirdparty/saveSetting', // 平台 添加设置
  thirdpartyDelSetting: 'thirdparty/delSetting', // 平台 删除设置
  thirdpartyFindSettingDetail: 'thirdparty/findSettingDetail', // 平台 设置详情
  thirdpartyFindSettingList: 'thirdparty/findSettingList', // 数据库设置列表
  thirdpartySaveDb: 'thirdparty/saveDb', // 平台 保存设置
  thirdpartyTestDb: 'thirdparty/testDb', // 平台 测试连接数据库
  thirdpartyFindDbList: 'thirdparty/findDbList', // 数据库连接信息
  thirdpartyFindTableList: 'thirdparty/findTableList', // 平台 数据库列表
  thirdpartyUpdateSort: 'thirdparty/updateSortSetting', // 平台 数据库列表-排序
  refreshApiSecret: 'thirdparty/refreshApiSecret', // 刷新或获取apisecret
  thirdpartySchemaList: 'thirdparty/getSchemaList', // 获取oracle表空间
  findThirdTableListNew: 'thirdparty/findTableListNew', // 获取第三方集成数据库表
  findThirdTableColumnList: 'thirdparty/findTableColumnList', // 第三方集成数据库表字段
  aliapicloudList: 'aliapicloud/plugin/list', // 获取人工智能插件列表
  settingAliapicloudCode: 'aliapicloud/plugin/settingAppCode', // 设置appCode

  getInstallPlugCodes: 'plug/getInstallPlugCodes', // 获取已安装插件
  getPlugCodes: 'plug/getPlugCodes', // 获取可安装插件
  findSSOList: 'plug/findSSOList', // 获取单点登录信息列表
  delPlug: 'plug/delPlug', // 删除插件
  delSSOInfo: 'plug/delSSOInfo', // 删掉单点登录信息
  installPlug: 'plug/installPlug', // 安装插件
  saveSSOInfo: 'plug/saveSSOInfo', // 保存单点登录信息
  saveSSOUserInfo: 'plug/saveSSOUserInfo', // 保存单点登录帐号信息
  checkSSOAuth: 'plug/checkSSOAuth', // 检查SSO授权用户
  getUserSSOInfo: 'plug/getUserSSOInfo', // 获取用户单点登录信息
  getSSODetail: 'plug/getSSODetail', // 获取单点登录详情
  getCardPlug: 'miniapp/getCardPlug', // 获取名片插件配置
  saveCardPlug: 'miniapp/saveCardPlug', // 获取名片插件配置

  /** ************************接口集成 END*********************************/

  /** ************************自动化匹配 START*********************************/
  automatchFindModuleList: 'automatch/findModuleList', // 获取应用及模块列表
  automatchFindList: 'automatch/findList', // 获取自动化匹配列表
  automatchFindFieldsList: 'automatch/findFieldsList', // 获取目标及源模块所有字段
  automatchSave: 'automatch/save', // 保存自动匹配
  automatchUpdate: 'automatch/update', // 编辑自动匹配
  automatchFindDetail: 'automatch/findDetail', // 编辑自动匹配
  automatchDel: 'automatch/del', // 删除自动匹配
  /** ************************自动化匹配 END*********************************/

  /** ************************聚合表&数据联动 START*********************************/
  getAllApplications: 'application/getAllApplications', // 数据来源级联列表
  getDataListFieldsForJuhe: 'layout/getDataListFieldsForAggregationSurface', // 根据模块bean获取数据列表 (聚合表规定的四种格式)
  getNumicFieldsForJuhe: 'layout/getNumicFieldsForAggregation', // 根据模块bean获取数据列表(纯数字格式)
  getJuheList: 'aggregationSurface/findAll', // 获取聚合表列表
  saveJuhe: 'aggregationSurface/save', // 新增聚合
  delJuhe: 'aggregationSurface/del', // 删除聚合
  getJuheById: 'aggregationSurface/getLayout', // 根据id获取聚合数据
  updateJuhe: 'aggregationSurface/update', // 编辑聚合
  gotoRun: 'aggregationSurface/getAggregationDataDetail', // 运行聚合表接口
  aggregationLinkageSave: 'aggregationLinkage/save', // 数据联动新增
  getLinkageList: 'aggregationLinkage/findAll', // 数据联动列表
  aggregationLinkageEdit: 'aggregationLinkage/update', // 数据联动编辑
  aggregationLinkageDel: 'aggregationLinkage/del', // 数据联动删除
  getFieldsForLinkage: 'layout/getFieldsForLinkage', // 获取模块的联动字段
  getLinkageDetail: 'aggregationLinkage/getLayout', // 根据id获取详情
  getLinkageFieldsForCustom: 'layout/getLinkageFieldsForCustom', // 获取模块配置的数据联动字段接口文档
  findAggregationDataLinkageList: 'aggregationLinkage/getLinkageData', // 联动字段变更请求相应数据接口文档
  /** ************************聚合表&数据联动 END***********************************/

  /** ************************工作台 START*********************************/
  queryListByFilterAuth: 'projectWorkbenchController/queryListByFilterAuth', // 获取工作台父列表
  queryWorkflowListBy: 'projectWorkbenchController/queryWorkflowListBy', // 获取工作台子列表
  queryTimeWorkbenchWebList: 'projectTaskWorkbench/queryTimeWorkbenchWebList', // 获取时间工作台列表
  moveTimeWorkbench: 'projectTaskWorkbench/moveTimeWorkbench', // 时间工作台拖动
  sortTimeWorkbench: 'projectTaskWorkbench/sortTimeWorkbench', // 时间工作台排序
  queryFlowWorkbenchWebList: 'projectTaskWorkbench/queryFlowWorkbenchWebList', // 获取企业工作流列表
  moveFlowWorkbench: 'projectTaskWorkbench/moveFlowWorkbench', // 企业工作流拖动
  getCardTaskSize: 'projectTaskWorkbench/getCardTaskSize', // 获取卡片（统计）数据
  getCardTaskData: 'projectTaskWorkbench/getCardTaskData', // 获取卡片（搜索）数据
  /** ************************工作台 END***********************************/

  /** ************************考勤 START**********************************/
  findWebList: 'attendanceClass/findWebList', //  班次管理列表
  attendanceClassSave: 'attendanceClass/save', //  新增班次管理
  attendanceClassFindDetail: 'attendanceClass/findDetail', //  根据id获取详情
  attendanceClassUpdate: 'attendanceClass/update', //  修改班次管理
  attendanceClassDel: 'attendanceClass/del', //  删除班次管理
  attendanceWayFindWebList: 'attendanceWay/findWebList', //  考勤方式列表
  attendanceWaySave: 'attendanceWay/save', //  新增考勤方式
  attendanceWayUpdate: 'attendanceWay/update', //  修改考勤方式
  attendanceWayFindDetail: 'attendanceWay/findDetail', //  根据id获取考勤方式详情
  attendanceWayDel: 'attendanceWay/del', //  根据id删除考勤方式
  attendanceGroupList: 'attendanceGroup/findWebList', //  获取打卡规则列表
  attendanceGroupSave: 'attendanceGroup/save', //  新增打卡规则
  attendanceGroupDel: 'attendanceGroup/del', //  删除打卡规则
  attendanceGroupDetail: 'attendanceGroup/findDetail', //  根据id获取打卡规则详情
  attendanceGroupUpdate: 'attendanceGroup/update', //  编辑打卡规则
  scheduleFindDetailById: 'attendanceGroup/findDetail', // 根据考勤组id获取排班详情
  attendanceManagementSave: 'attendanceManagement/save', // 保存排班表
  attendanceManagementUpdate: 'attendanceManagement/update', // 编辑排班表
  attendanceManagementDetail: 'attendanceManagement/findDetail', // 查询考勤组内人员排班详情
  attendanceManagementDataExport: 'attendanceManagement/attendanceManagementDataExport', // 排班导入
  attendanceManagementDataImport: 'attendanceManagement/attendanceManagementDataImport', // 排班导出
  attendanceCycleSave: 'attendanceCycle/save', // 新增排班周期
  attendanceCycleFindDetail: 'attendanceCycle/findDetail', // 根据id获取排班周期详情
  attendanceScheduleQueryList: 'attendanceCycle/queryList', // 获取排班周期列表
  attendanceCycleUpdate: 'attendanceCycle/update', // 编辑排班周期
  attendanceCycleDel: 'attendanceCycle/del', // 删除排班周期
  otherSetFindDetail: 'attendanceSetting/findDetail', // 其他设置-获取详情
  attendanceSettingSaveAdmin: 'attendanceSetting/saveAdmin', // 其他设置-新增管理员
  attendanceSettingSaveRemind: 'attendanceSetting/saveRemind', // 其他设置-新增打卡提醒
  attendanceSettingSaveCount: 'attendanceSetting/saveCount', // 其他设置-新增榜单设置
  attendanceSettingSaveLate: 'attendanceSetting/saveLate', // 其他设置-新增晚到晚走设置
  attendanceSettingSaveHommization: 'attendanceSetting/saveHommization', // 其他设置-新增人性化班次
  attendanceSettingSaveAbsenteeism: 'attendanceSetting/saveAbsenteeism', // 其他设置-新增旷工原则
  attendanceRelevanceApproveSave: 'attendanceRelevanceApprove/save', // 关联审批单-新增审批单
  attendanceRelevanceApproveUpdate: 'attendanceRelevanceApprove/update', // 关联审批单-修改关联审批单
  attendanceRelevanceApproveDel: 'attendanceRelevanceApprove/del', // 关联审批单-删除关联审批单
  attendanceRelevanceApproveFindDetail: 'attendanceRelevanceApprove/findDetail', // 关联审批单-根据ID查询详情
  attendanceRelevanceApproveFindList: 'attendanceRelevanceApprove/findList', // 关联审批单-获取列表数据
  attendanceRelevanceApproveFindApproveList: 'attendanceRelevanceApprove/findApproveList', // 关联审批单-获取可关联审批列表
  monthDataColumnList: 'attendanceReport/monthDataColumnList', // 获取月报表支持查询的列
  originaldataList: 'attendanceReport/originaldataList', // 获取打卡原始记录
  monthdataList: 'attendanceReport/monthdataList', // 月统计
  daydataList: 'attendanceReport/daydataList', // 每日统计
  originaldataListNew: 'attendanceReport/originaldataListNew', // 获取打卡原始记录
  monthdataListNew: 'attendanceReport/monthdataListNew', // 月统计
  daydataListNew: 'attendanceReport/daydataListNew', // 每日统计
  attendanceReportUpdate: 'attendanceReport/update', // 修改用户考勤记录
  attendanceReportBatchUpdate: 'attendanceReport/batchUpdate', // 批量修改用户考勤记录
  getAbnormalDataByAuth: 'attendanceReport/getAbnormalDataByAuth', // 获取异常考勤记录
  originaldataTemplateExport: 'attendanceReport/originaldataTemplateExport', // 下载原始模板
  originaldataImport: 'attendanceReport/originaldataImport', // 导入原始记录
  getApprovePassRecord: 'attendanceReport/getApprovePassRecord', // 前台-关联审批单
  deletePassRecord: 'attendanceReport/deletePassRecord', // 前台-删除审批单
  findUserAttendanceGroup: 'attendanceClock/findUserAttendanceGroup', // 获取当日考勤信息
  findPluginList: 'attendanceSetting/findPluginList', // 获取插件列表
  openOrClose: 'attendanceSetting/openOrClose', // 开启/关闭插件
  saveOvertimeRemind: 'attendanceSetting/saveOvertimeRemind', // 开启/关闭插件

  attendanceMachineSettingList: 'attendanceMachineSetting/list', // 获取考勤机列表
  attendanceMachineSettingsave: 'attendanceMachineSetting/save', // 考勤中控机保存和更新
  attendanceMachineSettingDel: 'attendanceMachineSetting/delete', // 中控机删除
  attendanceMachineSettingExist: 'attendanceMachineSetting/isExist', // 查询是否有重复的sn号
  attendanceMachineSettingPushAddress: 'attendanceMachineSetting/getPushAddress', // 获取地址
  attendanceMachineSettingSynchronization: 'attendanceMachineSetting/synchronization', // 获取地址
  attendanceMachineEmployeeRelationList: 'attendanceMachineEmployeeRelation/list', // 获取考勤机列表
  attendanceMachineEmployeeRelationSave: 'attendanceMachineEmployeeRelation/save', // 保存考勤机和人之间关系
  attendanceMachineEmployeeRelationDel: 'attendanceMachineEmployeeRelation/delete', // 人员删除
  attendanceMachineSettingCheckConn: 'attendanceMachineSetting/checkConn', // 验证考勤机

  attendanceHolidayList: 'attendanceHoliday/findList', // 获取假期余额列表
  updateAttendanceHoliday: 'attendanceHoliday/updateHoliday', // 手动修改假期余额
  attendanceHolidayLogList: 'attendanceHoliday/findLogList', // 假期余额变动记录接口
  attendanceHolidayDetail: 'attendanceHoliday/findDetail', // 获取单个假期余额
  attendanceHolidayTemplateExport: 'attendanceHoliday/attendanceHolidayTemplateExport', // 获取考勤假期导入模板
  holidayBalanceImport: 'attendanceHoliday/holidayBalanceImport', // 导入假期
  getMapConfig: 'attendanceHoliday/getSetAppKeys', // 获取地图配置
  updateAttendanceApproveRule: 'attendanceRelevanceApprove/updateRule', // 编辑补卡/假期/加班规则

  saveOverTimeRule: 'attendanceRelevanceApprove/saveOverTimeRule', // 新增考勤加班规则
  updateOverTimeRule: 'attendanceRelevanceApprove/updateOverTimeRule', // 编辑考勤加班规则
  deleteOverTimeRule: 'attendanceRelevanceApprove/deleteOverTimeRule', // 删除编辑考勤加班规则
  queryOverTimeRuleList: 'attendanceRelevanceApprove/queryOverTimeRuleList', // 获取考勤加班规则

  getAttendanceConfirmSetting: 'attendanceConfirm/getSetting', // 获取考勤确认配置
  saveAttendanceConfirmSetting: 'attendanceConfirm/saveSetting', // 设置考勤确认配置
  getAttendanceConfirmMonthReport: 'attendanceConfirm/getAttendanceConfirmMonthReport', // 获取考勤确认单
  getAttendanceConfirmMonthReportDetailList:
    'attendanceConfirm/getAttendanceConfirmMonthReportDetailList', // 获取考勤确认单明细
  attendanceConfirmSendOrRecallAll: 'attendanceConfirm/attendanceConfirmSendOrRecallAll', // 全部发送/全部撤回
  attendanceConfirmSendOrRecall: 'attendanceConfirm/attendanceConfirmSendOrRecall', // 发送/撤回单个
  confirmAttendanceConfirm: 'attendanceConfirm/confirm', // 确认考勤确认单
  getAttendanceConfirmMonthReportDetail: 'attendanceConfirm/getAttendanceConfirmMonthReportDetail', // 获取考勤确认单详情
  getAttendanceConfirmReportInfo: 'attendanceConfirm/getAttendanceConfirmMonthReportInfo', // 获取考勤确认单信息详情
  attendanceURGE: 'attendanceConfirm/uRGE', // 获取考勤确认单详情
  attendanceModifyRecordList: 'attendanceModifyRecord/findList', // 获取修改记录
  attendanceModifyRecordDel: 'attendanceModifyRecord/del', // 删除修改记录
  /** *************************考勤 END***********************************/

  /** ************************登录注册************************************/
  login: 'user/login', // 登录
  personalInfo: 'user/personalInfo', // 注册个人资料
  sendSmsCode: 'user/sendSmsCode', // 获取短信码
  verifySmsCode: 'user/verifySmsCode', // 验证短信码
  modifyPwd: 'user/modifyPwd', // 修改密码
  editPassWord: 'user/editPassWord', // 修改密码
  getCompanySet: 'user/getCompanySet', // 获取最近登录公司密码策略
  getCompanySetResetPwd: 'user/getCompanySetResetPwd', // 获取最近登录公司密码策略
  queryInfo: 'user/queryInfo', // 获取登录信息
  userRegister: 'user/userRegister', // 注册个人公司
  queryCode: 'user/queryCode', // 获取标识
  scanCodeLogin: 'user/scanCodeLogin', // 扫码登录
  companyList: 'user/companyList' /** 公司 列表 */,
  companyLogin: 'user/companyLogin' /** 切换公司 */,
  signOutAccount: 'user/signOutAccount' /** 切换公司 */,
  getCompanyDomainAddress: 'user/getCompanyDomainAddress' /** 获取域名地址GET */,
  editCompanyDomainAddress: 'user/editCompanyDomainAddress' /** 修改域名地址POST */,
  editCompanyImAddress: 'user/editCompanyImAddress' /** 修改IM地址POST */,
  getReleaseNotice: 'user/getReleaseNotice' /** 获取平台消息 */,
  getCompanyDataInfo: 'user/getCompanyDataInfo' /** 获取公司套餐使用情况 */,
  userSetting: 'user/setting' /** 自定义登录 */,
  getUserSetting: 'user/getSetting' /** 获取所有语言 */,
  getUserLanguages: 'user/getLanguages' /** 自定义登录 */,
  openUserSet: 'user/openSet' /** 自定义登录 */,
  queryWechatAccount: 'wechat/publicAccount/query' /** 获取公众号信息 */,
  saveWechatAccount: 'wechat/publicAccount/save' /** 保存公众号信息 */,
  updateWechatMenuEnableById: 'wechat/publicAccount/updateMenuEnableById' /** 更新启用状态 */,
  getTemplatebind: 'wechat/templatebind/list' /** 获取微信消息模板 */,
  saveTemplatebind: 'wechat/templatebind/save' /** 保存和更新微信消息模板 */,
  uploadWxJs: 'wechat/publicAccount/uploadWxJs' /** 上传微信公众号wxjs */,
  getnailingconfig:
    'dingding/in/application/getconfig' /** 获取配置配置信息包括扫码和自建应用信息  */,
  nailingScanSave: 'dingding/in/application/scan/save' /** 保存自建应用扫码配置信息  */,
  nailingSave: 'dingding/in/application/save' /** 保存钉钉配置 */,
  nailingScanCodeLogin: 'dingding/openapi/scanCodeLogin' /** 钉钉扫码登录 */,
  nailingScanLoginInfo: 'dingding/openapi/getScanLoginInfo' /** 获取钉钉扫码登录信息 */,
  nailingSsoConfig: '/dingding/in/application/sso/config/save' /** 获取钉钉扫码登录信息 */,
  qyscanLogin: '/qy/scanLogin' /** pc应用内扫码登录 */,
  qyscanLogin3rd: '/qy/scanLogin3rd' /** pc应用内扫码登录 */,
  wxscanLoginInit: '/qy/scanLoginInit/wwf6d2ac57edaf492b' /** pc扫码登录初始化参数 */,
  savewxscan: '/qy/saveApplication' /** 保存企业微信扫码登录信息 */,
  getwxscan: '/qy/getApplication' /** 保存企业微信扫码登录信息 */,
  getThirdPartyStatus: '/third/party/getThirdPartyStatus' /** 获取同步组织架构状态 */,
  thirdSynchronization: '/third/party/synchronization' /** 同步组织架构 */,
  thirdModifyPhonePass: '/third/party/modifyPhonePass' /** 同步组织架构 */,
  queryQyUserList: '/qy/queryQyUserList' /** pc获取企业微信用户绑定 */,
  bindQyUser: '/qy/bindUser' /** 企业微信绑定用户 */,
  qyUnbundling: '/qy/unbundling' /** 企业微信/钉钉解绑 */,
  scanLogin3rdOSS: '/qy/scanLogin3rdOSS' /** 企业微信免登录后台 */,
  /** **********登录注册 END******************************************************/

  /** ************************选成员组件************************************/
  findUsersByCompany: 'user/findUsersByCompany', // 获取全部部门-成员
  findCompanyDepartment: 'employee/findCompanyDepartment', // 获取全部部门
  queryRangeEmployeeList: 'employee/queryRangeEmployeeList', // 获取可选范围成员
  queryRangeDepartmentList: 'employee/queryRangeDepartmentList', // 获取可选范围部门
  getSharePersonalFields: 'layout/getSharePersonalFields', // 数据共享选人控件动态参数接口
  findOrganizationalStructureByType: 'user/findOrganizationalStructureByType', // 模糊搜索选人组件
  savaDepartment: 'employee/savaDepartment', // 保存部门
  queryEmployeeDepartment: 'employee/queryEmployeeDepartment', // 获取部门信息
  editDepartment: 'employee/editDepartment', // 编辑部门
  delDepartment: 'employee/delDepartment', // 删除部门
  savaEmployee: 'employee/savaEmployee', // 保存成员
  getEmployeeDetail: 'employee/getEmployeeDetail', // 获取员工详情
  editEmployee: 'employee/editEmployee', // 编辑成员
  editEmployeeLeader: 'employee/editLeader', // 设置负责人
  betchEditDepartment: 'employee/betchEditDepartment', // 保存调整部门
  employeeActivateRemind: 'employee/activateRemind', // 激活提醒
  employeeBetchEditEmployee: 'employee/betchEditEmployee', // 停用
  employeeBetchEditRole: 'employee/betchEditRole', // 更换角色
  employeeBetchAppendRole: 'employee/betchAppendRole', // 追加角色
  betchDelEmployee: 'employee/betchDelEmployee', // 删除员工
  queryEmployeeList: 'employee/queryEmployeeList', // 获取员分页列表
  queryEmployeePost: 'employee/queryPost', // 职务管理
  savaEmployeePost: 'employee/savaPost', // 职务管理
  editEmployeePost: 'employee/editPost', // 职务管理
  delEmployeePost: 'employee/delPost', // 删除职务
  sortDepartment: 'employee/sortDepartment', // 部门排序
  saveNoviceGuide: 'employee/saveNoviceGuide', // 保存工作台流程状态
  saveReferenceModule: 'employee/saveReferenceModule', // 关联员工详情
  getReferenceModule: 'employee/getReferenceModule', // 获取关联员工
  delReferenceModule: 'employee/delReferenceModule', // 关联员工详情
  /** **********选成员组件 END******************************************************/

  /** ************************导航************************************/
  saveApplicationModuleUsed: 'applicationModuleUsed/save', //  编辑应用常用模块
  queryModuleStatistics: 'module/queryModuleStatistics', //  快捷新增
  /** **********导航 END******************************************************/

  /** ************************文件库************************************/
  fileLibraryUpload: 'common/file/fileLibraryUpload', //  添加文件
  queryfileCatalog: 'fileLibrary/queryfileCatalog', //  获取模块导航
  fileEditMember: 'fileLibrary/editMember', //  修改文件夹管理员
  queryFileList: 'fileLibrary/queryFileList', //  获取公司文件根目录列表
  queryFilePartList: 'fileLibrary/queryFilePartList', //  公司子级目录
  queryAppFileList: 'fileLibrary/queryAppFileList', //  应用--应用文件夹
  queryModuleFileList: 'fileLibrary/queryModuleFileList', //  应用--模块文件夹
  queryModulePartFileList: 'fileLibrary/queryModulePartFileList', //  应用--模块文件
  fileQuitShare: 'fileLibrary/quitShare', //  退出共享
  fileCancelShare: 'fileLibrary/cancelShare', //  取消共享
  delFileLibrary: 'fileLibrary/delFileLibrary', //  删除文件
  copyFileLibrary: 'fileLibrary/copyFileLibrary', //  复制文件至...
  fileEditRename: 'fileLibrary/editRename', //  文件重命名
  shiftFileLibrary: 'fileLibrary/shiftFileLibrary', //  移动文件夹
  shareFileLibaray: 'fileLibrary/shareFileLibaray', //  文件共享
  editFolder: 'fileLibrary/editFolder', //  编辑文件夹提交
  fileEditManageStaff: 'fileLibrary/editManageStaff', //  保存管理员
  queryFolderInitDetail: 'fileLibrary/queryFolderInitDetail', //  文件夹详情
  fileUpdateSetting: 'fileLibrary/updateSetting', //  保存成员权限
  getBlurResultParentInfo: 'fileLibrary/getBlurResultParentInfo', //  获取文件夹路劲
  whetherFabulous: 'fileLibrary/whetherFabulous', //  文件点赞
  queryVersionList: 'fileLibrary/queryVersionList', //  查询文件版本记录
  queryDownLoadList: 'fileLibrary/queryDownLoadList', //  查询文件下载记录
  fileBlurSearchFile: 'fileLibrary/blurSearchFile', //  搜索文件夹
  savaFileLibrary: 'fileLibrary/savaFileLibrary', //  新建文件夹
  queryAidePower: 'fileLibrary/queryAidePower', //  小助手进入文件库权限
  queryFileLibarayDetail: 'fileLibrary/queryFileLibarayDetail', //  获取文件详情
  queryFileLibraryUrl: 'fileLibrary/queryFileLibraryUrl', //  打开公开链接
  openUrlSava: 'fileLibrary/openUrlSava', //  保存公开链接条件
  queryOpenUrlEmail: 'fileLibrary/queryOpenUrlEmail', //  获取公开链接邮件发送列表
  onlinePreview: 'common/online/preview', // pdf预览
  queryCompanyFileList: 'fileLibrary/queryCompanyFileList', //  获取公司文件根目录列表
  queryPersonalStatus: 'fileLibrary/queryPersonalStatus', //  后台获取是否开启
  updateIsOpen: 'fileLibrary/updateIsOpen', //  台设置是否开启个人文件
  saveFilelibraryAdministrator: 'fileLibrary/saveFilelibraryAdministrator', //  添加后台文件库管理员接口
  getFilelibraryAdministrators: 'fileLibrary/getFilelibraryAdministrators', //  获取文件库管理员列表接口
  isFilelibraryAdministrator: 'fileLibrary/isFilelibraryAdministrator', //  判断是否是文件库管理员接口
  getDeletedFileList: 'fileLibrary/getDeletedFileList', //  获取已删除的文件列表
  deleteCompletelyFile: 'fileLibrary/deleteCompletelyFile', //  彻底删除文件
  getApplicationModuleFiles: 'fileLibrary/getApplicationModule', //  获取应用模块列表（后台）
  viewFolder: 'fileLibrary/viewFolder', //  获取应用模块 显示设置（后台）
  /** **********文件库 END******************************************************/

  /** ************************企信************************************/
  addSingleChat: 'imChat/addSingleChat', //  添加单聊
  getListInfo: 'imChat/getListInfo', //  获取会话列表
  hideSession: 'imChat/hideSession', //  修改回话隐藏-显示
  changeGroupMember: 'imChat/changeGroupMember', //  管理群成员
  modifyGroupInfo: 'imChat/modifyGroupInfo', //  修改群设置
  quitGroup: 'imChat/quitGroup', //  退出群
  releaseGroup: 'imChat/releaseGroup', //  解散群
  imsetTop: 'imChat/setTop', //  置顶
  getGroupInfo: 'imChat/getGroupInfo', //  获取群信息
  addGroupChat: 'imChat/addGroupChat', //  创建群组
  getAllGroupsInfo: 'imChat/getAllGroupsInfo', //  获取企信当前用户所有组的信息
  IMreadMessage: 'imChat/readMessage', //  修改消息未读状态
  getAssisstantInfo: 'imChat/getAssisstantInfo', //  获取小助手设置相关信息
  markReadOption: 'imChat/markReadOption', //  只查看未读消息
  markAllRead: 'imChat/markAllRead', //  编辑应用常用模块
  IMfindModuleList: 'module/findModuleList', //  筛选
  getAssistantMessage: 'imChat/getAssistantMessage', //  获取助手消息列表
  hideSessionWithStatus: 'imChat/hideSessionWithStatus', //  显示-隐藏
  transferGroup: 'imChat/transferGroup', //  转让群主
  getUnreadAssistantMessage: 'imChat/getUnreadAssistantMessage', //  获取最近10条未读消息
  markAllAssistantRead: 'imChat/markAllAssistantRead', //  全部助手消息已读
  /** **********企信 END******************************************************/

  /** *************自定义 ***********************************************/
  getModuleFieldList: 'module/getBeanInitData', // 获取模块下所有字段（布局专用）
  submitLayout: 'layout/saveAllLayout', // 提交布局
  getEnableLayout: 'layout/getEnableLayout', // 获取已使用字段布局
  getEnableLayoutBack: 'layout/getEnableLayoutBack', // 获取已使用字段布局(本地部署新街口)
  getDisableLayout: 'layout/getDisableLayout', // 获取未使用布局信息
  getDisableLayoutBack: 'layout/getDisableLayoutBack', // 获取未使用布局信息(本地部署新街口)
  getRepeatCheckList: 'moduleOperation/getRecheckingFields', // 获取查重返回列表
  getReferenceList: 'moduleOperation/findRelationDataList', // 获取关联关系列表
  customSubmitData: 'moduleOperation/saveData', // 自定义模块新增数据
  customEditData: 'moduleOperation/updateData', // 自定义模块编辑数据
  customEditDataNew: 'moduleOperation/updateCompleteData', // 自定义模块编辑数据（给del_status为10的数据重复保存使用）
  customDeleteData: 'moduleOperation/deleteData', // 自定义模块删除数据
  getCustomList: 'moduleOperation/findDataList', // 自定义模块列表数据
  customDtlData: 'moduleOperation/findDataDetail', // 自定义模块详情数据
  customDtlRelationData: 'moduleOperation/findDataRelation', // 自定义模块详情关联关系数据
  customRelationList: 'moduleOperation/findDataRelationsForPc', // 自定义模块关联关系数据
  getCustomListShow: 'layout/getDataListFields', // 自定义模块列表显示数据
  getFilterList: 'moduleOperation/findFilterFields', // 自定义模块筛选列表
  addSubMenu: 'submenu/save', // 新增子菜单
  updateSubMenu: 'submenu/update', // 修改子菜单
  sortSubMenu: 'submenu/sequencing', // 子菜单排序
  deleteSubMenu: 'submenu/del', // 删除子菜单
  transferPrincipal: 'moduleOperation/transfor', // 转移负责人
  addDataShare: 'moduleSingleShare/save', // 新增数据共享
  updataDataShare: 'moduleSingleShare/update', // 修改数据共享
  highSeasPoolMove: 'moduleOperation/moveData2OtherSeapool', // 公海池移动
  highSeasPoolGet: 'moduleOperation/take', // 公海池领取
  highSeasPoolDistribute: 'moduleOperation/allocate', // 公海池分配
  highSeasPoolBack: 'moduleOperation/returnBack', // 公海池退回
  convertData: 'moduleOperation/transformation', // 转换数据
  getShareSetList: 'moduleSingleShare/getSingles', // 获取分享设置列表
  deleteShareData: 'moduleSingleShare/del', // 删除分享数据
  uploadImportFile: 'common/file/importUpload', // 上传导入模版
  dataImport: 'common/fileImport', // 数据导入
  saveDataListShow: 'layout/saveDataListFields', // 保存列表显示字段
  saveLabelShow: 'moduleOperation/saveDataRelation', // 保存标签显示字段
  getSubmenuList: 'submenu/getSubmenusForPC', // 获取子菜单列表
  deleteApp: 'application/del', // 删除应用
  createApp: 'application/save', // 新增应用
  updateApp: 'application/update', // 更新应用
  sortApp: 'application/sequencing', // 应用排序
  sortModules: 'module/sequencing', // 模块排序
  deleteModule: 'module/del', // 删除模块
  getAccountEmailList: 'mailOperation/queryMailListByAccount', // 获取账户邮件列表
  getModuleShareById: 'moduleDataShare/getModuleShareById', // 获取要编辑的数据共享
  getShareSave: 'moduleDataShare/save', // 新增数据点击保存
  getShareDel: 'moduleDataShare/del', // 删除数据共享
  getShareupdate: 'moduleDataShare/update', // 编辑数据共享
  getModuleDataShares: 'moduleDataShare/getModuleDataShares', // 获取字段共享列表
  getPicklistControlList: 'layout/getPicklistControl', // 获取选项依赖列表
  getMoudleIdByBean: 'moduleOperation/getModuleIdByModule', // 根据bean获取模块ID
  getChildLayout: 'layout/findSubpageist', // 获取多页面列表
  getAllMenuOfApp: 'module/findAllMsgByAuth', // 获取应用下所有模块及子菜单
  getFieldsOfWorkflow: 'automation/queryModuleFields', // 自定义工作流获取模块下插入字段
  getDataLinksInfo: 'webform/getWebformListForDetail', // 前端获取外部链接设置
  getWebformDataDetail: 'webform/getWebformDataDetail', // 获取数据外链详情
  getWebformEnableLayout: 'webform/getEnableLayout', // 获取数据外链数据布局
  getRandomBarcode: 'barcode/createBarcode', // 获取一个随机条形码
  getBarcodeImg: 'barcode/getBarcodeMsg', // 获取生成的条形码图片
  getReferenceModuleAuth: 'moduleOperation/isAuthClick', // 获取是否具有进入关联模块权限
  /** **********END************* *****************************************/

  /** ***************角色设置**********************************************/
  getAuthByRole: 'moduleDataAuth/getAuthByRole', // 获取模块的功能权限
  dataAuthGetRoleGroupList: 'moduleDataAuth/getRoleGroupList', // 数据权限获取角色分组
  modifyAuthByRole: 'moduleDataAuth/modifyAuthByRole', // 修改权限
  dataAuthGetAuthName: 'moduleDataAuth/initAuthName', // 获取表
  addRoleGroup: 'moduleDataAuth/addRoleGroup', // 新增分组
  renameRoleGroup: 'moduleDataAuth/renameRoleGroup', // 编辑分组
  deleteRoleGroup: 'moduleDataAuth/deleteRoleGroup', // 删除分组
  addAuthRole: 'moduleDataAuth/addRole', // 添加角色
  modifyAuthRole: 'moduleDataAuth/modifyRole', // 编辑角色
  copyRole: 'moduleDataAuth/copyRole', // 复制角色
  deleteAuthRole: 'moduleDataAuth/deleteRole', // 删除角色
  modifyUserByRole: 'moduleDataAuth/modifyUserByRole', // 添加角色成员
  getUserByRole: 'moduleDataAuth/getUserByRole', // 获取角色成员
  sortRole: 'role/sortRole', // 角色排序
  getBackAuthByRole: 'moduleDataAuth/getBackAuthByRole', // 获取指定角色的后台权限
  saveBackAuth: 'moduleDataAuth/saveBackAuth', // 保存后端权限

  /** ***************模块设置**********************************************/
  getProcessApproval: 'workflow/getWorkflowLayout', // 获取审批流程后台设置
  getWorkflowLayoutBack: 'workflow/getWorkflowLayoutBack', // 获取审批流程后台设置
  getfieldListWithoutReference: 'layout/getFieldsExceptReferenceByModule', // 获取当前模块除了关联关系所有字段
  getfieldListSelectField: 'layout/getAfterFieldsByCurrentField', // 获取选中字段下面的所有字段
  getFieldTransList: 'fieldTransform/getFieldTransformations', // 获取字段转换列表
  addFieldTransform: 'fieldTransform/save', // 新增字段转换
  editFieldTransform: 'fieldTransform/update', // 编辑字段转换
  delFieldTransform: 'fieldTransform/del', // 删除字段转换
  getFieldTransformation: 'fieldTransform/getFieldTransformationById', // 获取要编辑的字段装换
  queryInitAllotDateil: 'allot/queryInitAllotDateil', // 获取要编辑的自动分配
  queryAllotList: 'allot/queryAllotList', // 获取自动分配列表
  saveAllotRule: 'allot/ saveAllotRule', // 保存自动分配
  editAllotRule: 'allot/editAllotRule', // 编辑自动分配
  delAllot: 'allot/delAllot', // 删除自动分配
  queryColourList: 'recordStyle/queryColourList', // 获取自动标记颜色列表
  saveAtutoColor: 'recordStyle/saveColourRule', // 保存自动标记颜色
  editColourRule: 'recordStyle/editColourRule', // 编辑自动标记颜色
  saveWorkFlowAutoSettings: 'automation/saveAutomationRule', // 新增工作流自动化设置
  getWorkFlowAutoSettingsList: 'automation/queryAutomationList', // 获取工作流自动化设置列表
  getWorkFlowAutoSettingsDtl: 'automation/queryAutomationById', // 获取工作流自动化设置详情
  updateWorkFlowAutoSettings: 'automation/editAutomation', // 修改工作流自动化设置
  deleteWorkFlowAutoSettings: 'automation/deleteAutomation', // 删除工作流自动化设置
  getInitColourDateil: 'recordStyle/queryInitColourDateil', // 查询记录颜色详情
  deleteAutoColor: 'recordStyle/delColour', // 删除记录颜色
  getHighSeasList: 'seapool/getSeapools', // 获取公海池列表
  addHighSeas: 'seapool/save', // 新增公海池
  editHighSeas: 'seapool/update', // 编辑公海池
  deleteHighSeas: 'seapool/del', // 删除公海池
  getTeapoolById: 'seapool/getTeapoolById', // 获取要编辑的公海池
  getInitCondition: 'module/queryInitData', // 获取条件设置高级条件
  delProcessApproval: 'workflow/removeWorkflowLayout', // 删除流程审批后台设置
  savePushSettings: 'messagePushSetting/savePushSettings', // 新增消息推送
  editPushSettings: 'messagePushSetting/editPushSettings', // 新增消息推送
  deletePushSettings: 'messagePushSetting/deletePushSettings', // 删除消息推送规则
  forbidPushSettings: 'messagePushSetting/forbidPushSettings', // 禁止消息推送规则
  getPushList: 'messagePushSetting/getPushSettingsList', // 获取消息推送列表
  saveAppDataListFields: 'layout/saveAppDataListFields', // 保存APP列表布局
  getMaplist: 'fieldRelyon/findRelationMappedList', // 获取关联映射列表
  getRelyList: 'fieldRelyon/findRelationRelyList', // 获取关联依赖列表
  getOptionDepd: 'fieldRelyon/findOptionFieldRelyList', // 获取选项依赖列表
  getOptionctrl: 'fieldRelyon/findOptionFieldControlList', // 获取选项控制列表
  getMaplistUrl: 'fieldRelyon/findRelationMappedList', // 获取关联映射列表
  addRelationMap: 'fieldRelyon/saveRelationMapped', // 新增关联映射
  deleRelationMap: 'fieldRelyon/removeRelationMapped', // 删除关联映射
  editRelationMap: 'fieldRelyon/modifyRelationMapped', // 修改关联映射
  addRelationRely: 'fieldRelyon/saveRelationRely', // 新增关联映射
  deleteRelationRely: 'fieldRelyon/removeRelationRely', // 删除关联依赖
  editRelationRely: 'fieldRelyon/modifyRelationRely', // 修改关联依赖
  addOptionFieldDepd: 'fieldRelyon/saveOptionFieldRely', // 新增字段依赖
  editOptionDepd: 'fieldRelyon/modifyOptionFieldRely', // 编辑关联依赖
  delOptionDepd: 'fieldRelyon/removeOptionFieldRely', // 删除字段依赖
  addOptionFieldCtrl: 'fieldRelyon/saveOptionFieldControl', // 新增字段控制
  delOptionCtrl: 'fieldRelyon/removeOptionFieldControl', // 新增字段控制
  editOptionCtrl: 'fieldRelyon/modifyOptionFieldControl', // 编辑字段控制
  getOptionctrlUrl: 'fieldRelyon/findOptionFieldControlList', // 获取当前模块下拉列表字段的下拉选项
  getInitialParameter: 'messagePushSetting/getInitialParameter', // 初始化设置信息
  getDataListFields: 'layout/getDataListFields', // 获取APP列表布局
  uploadPrintFile: 'common/file/printUpload', // 上传打印excel文件
  downloadPrintFile: 'common/file/printDownload', // 打印示例模板下载
  createPrintTemplate: 'print/sava', // 新建打印模版
  updatePrintTemplate: 'print/edit', // 修改打印模版
  delPrintTemplate: 'print/delete', // 删除打印模版
  getPrintTemplateList: 'print/list', // 获取打印模版列表
  getPreviewPDF: 'print/preview', // 预览PDF
  getModuleAndRelModule: 'automation/queryAutomationBean', // 获取模块及关联模块
  getModuleAndRelModuleField: 'automation/queryBeanField', // 获取模块下字段
  getFindCompanyDepartment: 'employee/findCompanyDepartment', // 获取全部部门
  getFindUsersByCompany: 'user/findUsersByCompany', // 获取全部部门-成员
  getRoleGroupList: 'role/getRoleGroupList', // 获取全部部门-成员
  getPersonalFields: 'layout/getPersonalFields', // 获取全部部门-成员
  getQueryEmployee: '/employee/queryEmployee', // 搜索
  getModulePageList: '/modulePageAuth/getModulePageList', // 获取多页面数据权限
  modifyModulePageAuth: '/modulePageAuth/modifyModulePageAuth', // 页面变更数据权限
  findSubpageist: '/layout/findSubpageist', // 多页面的列表
  getOutLinksSettings: '/webform/getWebformDataExternalLinkSetting', // 获取外部链接设置
  saveOutLinksSettings: '/webform/saveWebformDataExternalLinkSetting', // 保存外部链接设置
  getRecordLockingList: '/recordStyle/getLockedList', // 获取记录锁定列表
  getRecordLockingDetail: '/recordStyle/getLockedLayout', // 获取记录锁定详情
  saveRecordLocking: '/recordStyle/saveLockedLayout', // 保存记录锁定
  delRecordLocking: '/recordStyle/delLockedLayout', // 删除记录锁定
  findDetailByName: 'moduleOperation/findDetailByName', // 根据name获取详情(用于数据列表点击获取图片详情信息以及子表单数据信息)
  /** **********END************* *****************************************/

  /** ***************************审批START*******************************/
  getAddModuleList: 'module/findAllModuleList', // 获取新增模块列表
  queryApprovalCount: 'approval/queryApprovalCount', // 获取审批数据数量(未读/未审批数量)
  querySearchMenu: 'approval/querySearchMenu', // 获取筛选列表数据
  queryApprovalList: 'approval/queryApprovalList', // 获取审批列表数据
  queryApprovalData: 'approval/queryApprovalData', // 获取审批数据
  approvalRead: 'approval/approvalRead', // 发送已读状态
  ccTo: 'workflow/ccTo', // 抄送审批
  urgeTo: 'workflow/urgeTo', // 催办审批
  revoke: 'workflow/revoke', // 撤销审批
  removeProcessApproval: 'workflow/removeProcessApproval', // 删除审批
  saveProcessApproval: 'workflow/saveWorkflow', // 保存审批
  /** ***************************END*********************************/

  /** **************************审批后台管理************************/
  getApprovalTypeList: 'approval/queryApprovaTypeList', // 获取审批类型列表
  getApprovalManageList: 'approval/selectApprovalList', // 获取后台审批列表
  delApprovalManageData: 'approval/editApprovalStatus', // 删除后台审批数据
  getApprovalFlowList: 'workflow/getProcessWholeFlow', // 获取审批流程
  /** ******************************END**************************/

  /** ********统计分析-自定义图表 *******************/
  getSourceRelationModule: 'report/getSourceRelationModule', // 获取关联模块数据源
  getSourceField: 'report/getSourceField', // 获取数据源字段
  saveDashBoard: 'instrumentPanel/save', // 保存仪表盘
  previewSinge: 'instrumentPanel/showSingle', // 预览图表
  showSingleForReport: 'instrumentPanel/showSingleForReport', // 预览图表2
  getDashList: 'instrumentPanel/findAll', // 获取仪表盘列表
  getDashLayout: 'instrumentPanel/getLayout', // 获取仪表盘布局
  delDashLayout: '/instrumentPanel/del', // 删除仪表盘
  editDashLayout: '/instrumentPanel/update', // 编辑仪表盘
  runSinge: '/instrumentPanel/runSingle', // 单个图表运行
  /** *************END *****************************/

  /** **************************邮件设置**************************/
  saveMailAccount: '/mailAccount/save',
  editMailAccount: '/mailAccount/edit',
  mailAccountQueryById: '/mailAccount/queryById',
  delMailAccount: '/mailAccount/delete',
  mailAccountQueryList: '/mailAccount/queryList',
  validateAccount: '/mailAccount/validateAccount',
  openOrCloseAccount: '/mailAccount/openOrCloseAccount',
  setDefaultAccount: '/mailAccount/setDefaultAccount',
  getReceiveSettingInfo: '/mailAccount/getReceiveSettingInfo', // 获取邮箱收件时长设置
  saveReceiveSetting: '/mailAccount/saveReceiveSetting', // 设置邮箱收件时长
  addMailSignature: '/mailSignature/sava',
  mailSignatureQueryById: '/mailSignature/queryById',
  mailSignatureEdit: '/mailSignature/edit',
  delMailSignature: '/mailSignature/delete',
  mailSignatureQueryList: '/mailSignature/queryList',
  openOrSignature: '/mailSignature/openOrSignature',
  setDefaultSignature: '/mailSignature/setDefaultSignature',
  mailWhiteBlackQueryList: '/mailWhiteBlack/queryList',
  saveMailWhiteBlack: '/mailWhiteBlack/sava',
  mailCatalogqueryList: '/mailCatalog/queryList', // 通讯录列表
  delMailWhiteBlack: '/mailWhiteBlack/delete',
  queryPersonnelAccount: '/mailAccount/queryPersonnelAccount', // 获取适用账号
  mailTagQueryList: '/mailTag/queryList',
  mailTagSave: '/mailTag/sava',
  delMailTag: '/mailTag/delete',
  mailTagQueryById: '/mailTag/queryById',
  mailTagEdit: '/mailTag/edit',
  mailReceiveRegulationQueryList: '/mailReceiveRegulation/queryList',
  getInitailParameters: '/mailReceiveRegulation/getInitailParameters',
  mailTagQueryTagList: '/mailTag/queryTagList', // 已过滤掉禁用的标签列表
  saveMailReceiveRegulation: '/mailReceiveRegulation/save',
  editMailReceiveRegulation: '/mailReceiveRegulation/edit',
  mailReceiveRegulationQueryById: '/mailReceiveRegulation/queryById',
  openOrCloseRegulation: '/mailReceiveRegulation/openOrCloseRegulation',
  delmailReceiveRegulation: '/mailReceiveRegulation/delete',
  backOperationBlurMail: '/backOperation/blurMail',
  delBackOperation: '/backOperation/delete',
  getEmailWhere: '/workflow/getEmailWhere', // 获取邮件初始化条件
  delMailCatalog: '/mailCatalog/delete',
  saveMailCatalog: '/mailCatalog/sava',
  getProcessTypeForMail: 'workflow/checkChooseNextApproval', // 获取邮件审批的流程类型
  emailImageUpload: '/common/file/emailImageUpload',

  getMailTempManager: '/mailTemp/getManager', // 获取邮件模块管理员
  saveMailTempManager: '/mailTemp/saveManager', // 编辑邮件模块管理员
  queryMailTempList: '/mailTemp/queryMailTempList', // 获取邮件模板
  addMailTemp: '/mailTemp/addMailTemp', // 新建邮件模板
  updateMailTemp: '/mailTemp/updateMailTemp', // 编辑邮件模板
  deleteMailTemp: '/mailTemp/deleteMailTemp', // 删除邮件模板
  isMailTempAdmin: '/mailTemp/isAdmin', // 判断是否是邮件管理员

  saveMailShare: '/mailShare/save', // 新增邮件共享规则
  editMailShare: '/mailShare/edit', // 编辑邮件共享规则
  deleteMailShare: '/mailShare/delete', // 删除共享规则
  queryMailShareById: '/mailShare/queryById', // 获取邮件规则信息
  queryMailShareList: '/mailShare/queryList', // 获取邮件规列表
  queryEmailShareEmployeeList: '/mailShare/queryEmailShareEmployeeList', // 获取邮件规列表

  mailCommonsave: '/mailAccount/mailCommonsave', // 保存邮箱
  queryCommonAccountList: '/mailAccount/queryCommonAccountList', // 获取公共邮箱列表
  commonAccountDel: '/mailAccount/commonAccountDel', // 删除公共邮箱
  /** **************************END******************************/

  /** **************************协作前台**************************/
  getQueryCommentDetail: 'common/queryCommentDetail',
  postSavaCommonComment: 'common/savaCommonComment',
  postFileVersionUpload: 'common/file/fileVersionUpload',
  postWhetherFabulous: 'employee/whetherFabulous',
  getQueryEmployeeInfo: 'employee/queryEmployeeInfo',
  postEditEmployeeDetail: 'employee/editEmployeeDetail',
  shareSave: 'projectShareController/save', // 协作分享新增
  shareEdit: 'projectShareController/edit', // 协作分享修改
  shareDelete: 'projectShareController/delete', // 协作分享删除
  shareEditRelevance: 'projectShareController/editRelevance', // 协作分享关联变更
  shareStick: 'projectShareController/shareStick', // 协作分享置顶
  sharePraise: 'projectShareController/sharePraise', // 协作分享点赞
  shareQueryById: 'projectShareController/queryById', // 协作分享详情
  shareQueryList: 'projectShareController/queryList', // 协作分享列表数据
  queryShareRelationList: 'projectShareController/queryRelationList', // 协作分享获取关联内容
  shareCancleRelation: 'projectShareController/cancleRelation', // 协作分享取消关联内容
  shareSaveRelation: 'projectShareController/saveRelation', // 协作分享新建关联内容
  saveInformation: 'projectSettingController/saveInformation', // 基本设置的保存项目信息
  saveSetting: 'projectSettingController/saveSetting', // 保存项目设置
  editStatus: 'projectSettingController/editStatus', // 状态设置
  queryLabelsList: 'projectSettingController/queryLabelsList', // 获取标签
  queryTaskAuthList: 'projectSettingController/queryTaskAuthList', // 获取任务权限
  projectQueryById: 'projectSettingController/queryById', // 查询基本设置详情
  editLabels: 'projectSettingController/editLabels', // 项目标签变更
  editTaskAuth: 'projectSettingController/editTaskAuth', // 任务权限变更
  projectControllerSave: 'projectController/save', // 保存项目信息
  queryMainNode: 'projectController/queryMainNode', // 获取项目主节点
  querySubNode: 'projectController/querySubNode', // 获取项目子节点
  queryAllNode: 'projectController/queryAllNode', // 获取项目所有节点
  saveMainNode: 'projectController/saveMainNode', // 保存项目主节点
  editMainNode: 'projectController/editMainNode', // 主节点重命名
  deleteMainNode: 'projectController/deleteMainNode', // 删除主节点
  sortMainNode: 'projectController/sortMainNode', // 主节点拖动排序
  saveSubNode: 'projectController/saveSubNode', // 保存子节点
  editSubNode: 'projectController/editSubNode', // 子节点重命名
  deleteSubNode: 'projectController/deleteSubNode', // 删除项目子节点
  sortSubNode: 'projectController/sortSubNode', // 子节点拖动排序
  queryTaskList: 'projectController/queryTaskList', // 获取子节点下任务列表
  queryAllWebList: 'projectController/queryAllWebList', // 获取全部项目列表
  queryProjectList: 'projectController/queryAllList', // 获取分页项目列表
  queryMyLeaderWebList: 'projectController/queryMyLeaderWebList', // 获取我负责的项目列表
  queryMyJoinWebList: 'projectController/queryMyJoinWebList', // 获取我参与的项目列表
  queryMyCreateWebList: 'projectController/queryMyCreateWebList', // 获取我创建的项目列表
  queryOngoingWebList: 'projectController/queryOngoingWebList', // 获取进行中的项目列表
  queryCompletedWebList: 'projectController/queryCompletedWebList', // 获取已完成的项目列表
  MemberQueryList: 'projectMemberController/queryList', // 获取成员列表
  MemberQueryById: 'projectMemberController/queryById', // 根据ID查询详情
  MemberSave: 'projectMemberController/save', // 新增成员
  MemberUpdate: 'projectMemberController/update', // 修改成员
  MemberDelete: 'projectMemberController/delete', // 删除成员
  deleteTaskMember: 'projectMemberController/deleteTaskMember', // 删除协作人
  queryTaskWebList: 'projectTaskController/queryWebList', // 获取子节点下任务列表
  saveTaskWeb: 'projectTaskController/save', // 新增任务
  quoteTaskWeb: 'projectTaskController/quote', // 引用任务
  batchTaskWeb: 'projectTaskController/batch', // 任务批量操作
  queryByIdTaskWeb: 'projectTaskController/queryById', // 根据任务id查详情
  updateTaskWeb: 'projectTaskController/update', // 修改任务协作人可见不可见
  deleteTaskWeb: 'projectTaskController/delete', // 删除任务
  sortTaskWeb: 'projectTaskController/sort', // 任务拖拽排序
  saveSubTaskWeb: 'projectTaskController/saveSub', // 新增子任务
  updateSubTaskWeb: 'projectTaskController/updateSub', // 修改子任务
  deleteSubTaskWeb: 'projectTaskController/deleteSub', // 删除子任务
  querySubByIdTaskWeb: 'projectTaskController/querySubById', // 根据子任务id查详情
  querySubListTaskWeb: 'projectTaskController/querySubList', // 获取任务下子任务列表
  queryRelationListTaskWeb: 'projectTaskController/queryRelationList', // 获取任务下关联列表
  queryByRelationListTaskWeb: 'projectTaskController/queryByRelationList', // 获取任务下被关联列表
  saveRelationTaskWeb: 'projectTaskController/saveRelation', // 子任务新增关联
  quoteRelationTaskWeb: 'projectTaskController/quoteRelation', // 子任务引用关联
  cancleRelationTaskWeb: 'projectTaskController/cancleRelation', // 取消子任务关联
  updateTaskStatus: 'projectTaskController/updateStatus', // 任务勾选完成状态复选框
  updateSubTaskStatus: 'projectTaskController/updateSubStatus', // 子任务勾选完成状态复选框
  tasksharePraise: 'projectShareController/sharePraise', // 任务上的点赞与取消点赞
  updatePassedStatus: 'projectTaskController/updatePassedStatus', // 任务上的通过按钮
  updateSubPassedStatus: 'projectTaskController/updateSubPassedStatus', // 子任务上的通过按钮
  saveTaskMember: 'projectMemberController/saveTaskMember', // 新增项目任务协作人
  queryCollaboratorList: 'projectMemberController/queryTaskList', // 获取协助人列表
  updateTaskDetail: 'projectTaskController/updateTask', // 修改任务
  getProjectEnableLayout: 'projectLayout/getEnableCLayout', // 获取任务自定义使用字段布局
  saveProjectLayout: 'projectLayoutOperation/save', // 保存任务自定义业务数据
  editProjectLayout: 'projectLayoutOperation/edit', // 修改任务自定义数据
  queryProjectDataDetail: 'projectLayoutOperation/queryDataDetail', // 获取任务自定义数据
  queryByHierarchy: 'projectTaskController/queryByHierarchy', // 任务层级关系接口
  queryManagementRoleInfo: 'projectMemberController/queryManagementRoleInfo', // 查询获取成员列表成员的权限
  findApprovalModuleList: 'module/findApprovalModuleList', // 获取审批模块列表 或  审批获取模块数据列表
  queryProjectApprovaList: 'approval/queryProjectApprovaList', // 获取审批模块列表 或  审批获取模块数据列表
  queryProjectTaskConditions: 'projectTaskController/queryProjectTaskConditions', // 获取任务筛选自定义条件接口
  queryProjectTaskListByCondition: 'projectTaskController/queryProjectTaskListByCondition', // 项目任务筛选接口
  updateTaskSubNode: 'projectTaskController/updateTaskSubNode', // 移动任务指定分列下面
  editProgress: 'projectSettingController/editProgress', // 更新项目项目进度
  editTaskSort: 'projectSettingController/editTaskSort', // 项目任务设置，修改任务排序与任务设置
  updateProjectAsterisk: 'projectController/updateProjectAsterisk', // 更新项目星标
  queryTaskListByCondition: 'personelTask/queryTaskListByCondition', // 获取任务列表(个人任务筛选)
  findAllModuleListByAuth: 'personelTask/findAllModuleListByAuth', // 获取所有自定义模块根据当前登陆人权限
  findDataListByModuleAuth: 'personelTask/findDataListByModuleAuth', // 搜索模块数据
  personelTaskSave: 'personelTask/save', // 新增个人任务数据
  personelTaskupdate: 'personelTask/update', // 编辑个人任务数据
  deletePersonelData: 'personelTask/deleteData', // 删除个人任务数据
  queryProjectEmployee: 'employee/queryProjectEmployee', // 人员卡片信息
  findPersonelTaskConditions: 'personelTask/findPersonelTaskConditions', // 获取任务筛选条件
  queryQuoteList: 'projectTaskController/queryQuoteList', // 获取引用任务列表
  copyTask: 'projectTaskController/copyTask', // 复制任务
  queryTaskViewStatus: 'projectTaskController/queryTaskViewStatus', // 查看任务/子任务状态
  getTaskRemind: 'projectTaskRemind/getTaskRemindList', // 任务-获取设置任务提醒
  saveTaskRemind: 'projectTaskRemind/saveData', // 任务-保存设置任务提醒
  updateRemind: 'projectTaskRemind/updateData', // 任务-编辑任务设置提醒数据
  getPersonelDataDetail: 'personelTask/getDataDetail', // 获取个人任务详情
  updateForFinish: 'personelTask/updateForFinish', // 勾选个人任务完成
  querySubTaskByTaskId: 'personelTask/querySubTaskByTaskId', // 根据任务id所有子任务
  getPersonelSubDataDetail: 'personelSubTask/getDataDetail', // 获取个人子任务详情
  savePersonelSubData: 'personelSubTask/saveData', // 新增个人子任务数据
  personelSubupdate: 'personelSubTask/update', // 编辑个人子任务数据
  deletePersonelSubData: 'personelSubTask/deleteData', // 删除个人子任务数据
  updateSubForFinish: 'personelSubTask/updateForFinish', // 勾选个人子任务完成
  saveAssociatesData: 'personelTaskAssociates/saveData', // 新增关联数据
  deleteAssociatesData: 'personelTaskAssociates/deleteData', // 删除关联数据
  queryTaskAssociatesByTaskIdAndType: 'personelTaskAssociates/queryTaskAssociatesByTaskIdAndType', // 根据任务id,任务类型获取任务关联
  queryBeTaskAssociatesByTaskIdAndType:
    'personelTaskAssociates/queryBeTaskAssociatesByTaskIdAndType', // 根据任务id,任务名称获取被关联的（子任务不会被关联）
  savePersonelMemberData: 'personelTaskMember/saveData', // 添加任务协作人
  deletePersonelMemberData: 'personelTaskMember/deleteData', // 删除任务协作人
  updateTaskPersonelMemberData: 'personelTaskMember/updateTask', // 协作人可见不可见
  queryMembersTaskId: 'personelTaskMember/queryMembersTaskId', // 获取任务协作人
  savePraiseRecordData: 'personelTaskPraiseRecord/saveData', // 点赞/取消点赞
  getPraisePerson: 'personelTaskPraiseRecord/getPraisePerson', // 获取点赞人
  saveTaskRemindData: 'personelTaskRemind/saveData', // 新增任务设置数据
  deleteTaskRemindData: 'personelTaskRemind/deleteData', // 删除任务设置数据
  findTaskListByProjectId: 'personelTask/findTaskListByProjectId',
  praiseQueryList: 'projectShareController/praiseQueryList', // 任务上的点赞列表（子任务与任务）
  projectFileUpload: 'common/file/projectFileUpload', // 任务上的上传接口
  queryAllTagList: 'taskTagController/queryAllTagList', // 获取所有标签带结构
  queryPersonelTaskViewStatus: 'personelTaskMember/queryTaskViewStatus', // 获取个人任务的状态
  queryNodesNameById: 'projectWorkflow/queryNodesNameById', // 获取工作流及其节点信息
  querProjectyWorkflowList: 'projectWorkflow//queryDataList', // 查询项目企业工作流列表
  getPersonQueryTaskList: 'personelTask/queryTaskList', // 获取个人任务业务数据列表
  getPersonQueryCommonTaskList: 'personelTask/queryCommonTaskList', // 获取项目任务个人任务业务数据列表
  queryModuleList: 'module/queryModuleList', // 获取自动化流程，所有模块
  projectQueryAutomationById: 'taskAutomation/queryAutomationById', // 获取协作自动化设置信息
  projectEditAutomation: 'taskAutomation/editAutomation', // 协作自动化设置修改
  projectSaveAutomationRule: 'taskAutomation/saveAutomationRule', // 自动化设置添加
  projectQueryAutomationList: 'taskAutomation/queryAutomationList', // 自动化设置列表
  projectDeleteAutomation: 'taskAutomation/deleteAutomation', // 协作自动化删除
  projectQueryAutomationBean: 'taskAutomation/queryAutomationBean', // 获取模块及关联模块下拉数据
  projectQueryBeanField: 'taskAutomation/queryBeanField', // 获取模块下字段下拉数据
  queryProjectWorkbenchWebList: 'projectTaskController/queryProjectWorkbenchWebList', // 获取项目工作台数据
  ProjectyquerWorkflowList: 'projectLayout/queryInitData', // 任务匹配初始化查询
  findTaskListForPageByProjectId: 'personelTask/findTaskListForPageByProjectId', // 获取项目任务业务数据列表
  queryTaskEmployee: 'taskAutomation/queryTaskEmployee', // 项目工作流获取人员，编辑任务反选
  saveProjectToTemplate: 'projectTemplateController/saveProjectToTemplate', // 保存项目模板
  queryProjectTemplateList: 'projectTemplateController/queryProjectTemplateList', // 获取项目模板
  deleteProjectTemplate: 'projectTemplateController/deleteProjectTemplate', // 删除项目模板
  queryProjectTemplateAllNode: 'projectTemplateController/queryAllNode', // 获取模板任务分组
  getTaskRemindList: 'personelTaskRemind/getTaskRemindList', // 获取个人任务的提醒数据
  personelTaskupdateData: 'personelTaskRemind/updateData', // 修改个人任务设置
  personelTaskRepeatSaveData: 'personelTaskRepeat/saveData', // 新增任务重复设置
  updateTaskRepeatData: 'personelTaskRepeat/updateData', // 编辑任务重复设置
  getTaskRepeatList: 'personelTaskRepeat/getTaskRepeatList', // 获取任务重复设置列表
  projectDataImport: 'common/projectDataImport', // 模板数据处理
  getTaskRoleFromPersonelTask: 'personelTaskMember/getTaskRoleFromPersonelTask', // 获取个人在个人任务中的角色
  queryTaskAnalysisByProjectId: 'projectTaskController/queryTaskAnalysisByProjectId', // 查看任务进度
  queryKanbanTaskNodeList: 'projectTaskController/queryTaskNodeList', // 通过分组获取列表以及任务
  queryAllTaskList: 'projectTaskController/queryAllTaskList', // 获取项目下所有任务
  queryTaskModuleList: 'projectTaskController/queryTaskModuleList', // 获取项目下面的所有模块
  queryTaskListByModuleId: 'projectTaskController/queryTaskListByBeanName', // 通过模块获取模块下面的任务
  projectTasksaveData: 'projectTaskRepeat/saveData', // 项目任务设置重复任务
  projectTasksupdateData: 'projectTaskRepeat/updateData', // 项目任务编辑重复任务
  projectTaskgetTaskRepeatList: 'projectTaskRepeat/getTaskRepeatList', // 获取项目任务重复任务设置
  updateSubNodeDataType: 'projectController/updateSubNodeDataType', // 修改任务列表数类型
  queryRelationModuleList: 'projectWorkbenchRelationModulController/queryRelationModuleList', // 获取工作台关联模块列表
  getRelationModuleInfo: 'projectWorkbenchRelationModulController/getRelationModuleInfo', // 获取工作台关联模块信息
  workbenchRelationSave: 'projectWorkbenchRelationModulController/save', // 保存工作台关联模板
  workbenchRelationUpdate: 'projectWorkbenchRelationModulController/update', // 工作台修改关联模板
  workbenchRelationDel: 'projectWorkbenchRelationModulController/del', // 删除关联模块
  projectWorkbenchEmployeeList: 'projectTaskWorkbench/employeeList', // 获取工作台可查看人员列表
  changeEmployeePrivilege: 'projectTaskWorkbench/changeEmployeePrivilege', // 任务工作台是否有权限切换用户
  queryTaskWorkbenchList: 'projectTaskWorkbench/queryTaskWorkbenchList', // 任务工作台获取列表
  queryQuoteTask: 'projectTaskController/queryQuoteTask', // 获取关联任务
  editRemind: 'projectSettingController/editRemind', // 编辑项目提醒
  replacer: 'projectMemberController/replacer', // 移出成员是否需要指定工作交接人
  projectMemberDelete: 'projectMemberController/delete', // 移出项目成员
  cancleQuote: 'projectTaskController/cancleQuote', // 取消引用任务（模块数据）
  cancleShareRelation: 'projectShareController/cancleRelation', // 分享取消关联

  queryProjectLibraryList: 'projectLibrary/queryLibraryList', // 文库分组列表
  queryProjectFileLibraryList: 'projectLibrary/queryFileLibraryList', // 文库列表
  queryTaskLibraryList: 'projectLibrary/queryTaskLibraryList', // 附件列表
  searchTaskLibraryList: 'projectLibrary/searchTaskLibraryList', // 搜索附件列表

  savaProjectFileLibrary: 'projectLibrary/savaFileLibrary', // 添加文件夹
  editProjectLibrary: 'projectLibrary/editLibrary', // 修改文件夹
  delProjectLibrary: 'projectLibrary/delLibrary', // 删除文件、夹
  sharProjectLibrary: 'projectLibrary/sharLibrary', // 共享文件
  projectDownload: 'common/file/projectDownload', // 文件下载
  projectDownloadList: 'projectLibrary/queryDownLoadList', // 文件下载
  projectPersonalUpload: 'common/file/projectPersonalUpload', // 上传文件
  batchDownloadProject: 'library/file/batchDownloadProject', // 项目文件夹下载
  /** **************************END**************************/

  /** **************************备忘录**************************/
  uploadForMemo: '/common/file/upload', // 上传文件公共接口
  saveMemo: '/memo/save', // 保存备忘录
  findMemoListTask: '/memo/findMemoList', // 获取备忘录列表 (任务新建引用，需分页)
  findMemoList: '/memo/findMemoWebList', // 获取备忘录列表 (新版本,无分页功能)
  findMemoDetail: '/memo/findMemoDetail', // 根据id获取备忘录详情
  memoEdit: '/memo/update', // 编辑备忘录
  memoDel: '/memo/del', // 删除/彻底删除/退出共享备忘录
  getFirstFieldFromModule: 'moduleOperation/getFirstFieldFromModule', // 根据模块查询数据
  getFuncAuthWithCommunal: 'moduleDataAuth/getFuncAuthWithCommunal', // 获取查看关联模块的权限
  memoFindRelationList: 'memo/findRelationList', // 获取自定义关联数据列表
  memoUpdateRelationById: 'memo/updateRelationById', // 变更关联关系接口
  /** **************************备忘录END**************************/

  /** **************************前台邮件**************************/
  EmailTitleCount: '/mailOperation/queryUnreadNumsByBox', // 获取邮件未读数
  getEmailLabelList: '/mailOperation/queryTagList', // 获邮件标签的列表
  getEmailListContent: '/mailOperation/queryList', // 获取邮件各个列表
  EMailAllMarkRead: '/mailOperation/markAllRead', // 邮件全部标记为已读
  EmailMarkRead: '/mailOperation/markMailReadOrUnread', // 邮件批量标记为已读未读
  EmailMoveLabel: '/mailOperation/moveToTag', // 邮件移动到标签
  getEmailListParticulars: '/mailOperation/queryById', // 获取邮件详情
  getEmailAndRecordsList: '/mailOperation/queryConnection', // 获取邮件的来往记录的列表数据
  EmailRejection: '/mailOperation/refuseReceive', // 邮件拒收
  EmailDeleteCancel: '/mailOperation/deleteDraft', // 邮件的删除
  EmailCompletelyCancel: '/mailOperation/clearMail', // 邮件的彻底删除
  getEmailReceiving: '/mailOperation/receive', // 邮件的收信
  EmailisJunkMail: '/mailOperation/markNotTrash', // 邮件的这不是垃圾邮件接口
  EmailDustbinTransfer: '/mailOperation/moveToBox', // 邮件转移到其他邮箱
  getEmailContactsList: '/mailContact/queryList', // 邮件获取最近联系人
  SelectContactFromModule: '/moduleEmail/getModuleEmails', // 邮件从模块中选择联系人
  CommonRequestMethodSubmenusModuleClassification: '/moduleEmail/getModuleSubmenus', // 获取模块分类的子菜单的公共请求方法
  selectModuleGetEmailContact: '/moduleEmail/getEmailFromModuleDetail', // 选择模块时获取到联系人的Email
  EmailSaveDraft: '/mailOperation/saveToDraft', // 邮件保存至草稿
  compileSaveDraft: '/mailOperation/editDraft', // 邮件编辑保存
  EmailSendTransmission: '/mailOperation/send', // 邮件写信的发送
  EmailInterfaceSend: '/mailOperation/mailReply', // 邮件的回复发送
  EmailForwardingSend: '/mailOperation/mailForward', // 邮件的转发发送
  EmailDraftManualSend: '/mailOperation/manualSend', // 邮件草稿箱的审批通过手动发送
  removeMailTag: '/mailOperation/removeMailTag', // 移除标签
  queryEmailFileAuth: 'fileLibrary/queryEmailFileAuth', // 从文件库获取附件的权限判断
  receiptMail: 'mailOperation/receiptMail', // 回执接口
  delMailContact: 'mailContact/deleteEmployeeAllMailLatestAccount', // 清空最近联系人
  /** **************************END**************************/

  /** **************************企业设置**************************/
  getApplyList: '/application/getApplications', // 获取应用列表请求
  modificationCompany: '/user/editCompany', // 修改公司信息
  queryCompanyBanner: '/user/queryCompanyBanner', // 获取banner 图
  transferEnterprise: '/user/editCompanyOwner', // 转让企业
  editCompanyAddress: '/user/editCompanyAddress', // 转让企业
  getCompanyAddress: '/user/getCompanyAddress', // 转让企业
  imageUpload: 'common/file/imageUpload', // 图片上传
  getEstablishModule: '/application/findApplicationsDetail', // 获取创建应用数量或模块数量
  getRoleFunctionList: '/role/getFunctionList', // 获取功能清单
  commonBackupList: '/common/backupList', // 备份文件列表
  commonExportData: '/common/exportData', // 导出数据
  commonBackupData: '/common/backupData', // 还原数据
  commonBackupMoveData: '/common/backupMoveData', // 数据迁移还原
  commonUploadBackFile: '/common/uploadBackFile', // 上传备份文件
  downloadBackupFile: '/common/downloadBackupFile', // 下载备份文件
  dealYunCompanyData: '/common/dealYunCompanyData', // 云端备份
  /** **************************END**************************/

  /** **************************员工管理**************************/
  importEmployees: 'common/file/importEmployees', // 图片上传
  editPassWords: '/user/editPassWords', // 批量重置密码接口
  /** **************************END**************************/

  /** **************************自定义报表**************************/
  // getSourceRelationModule: '/report/getSourceRelationModule',
  // getSourceField: '/report/getSourceField',
  saveReport: '/report/saveReport',
  getReportList: '/report/getReportList',
  removeReport: '/report/removeReport',
  getReportLayoutDetail: '/report/getReportLayoutDetail',
  getReportDataDetail: '/report/getReportDataDetail',
  getFilterFields: '/report/getFilterFields',
  getReportFilterFields: '/report/getReportFilterFields',
  getReportEditLayoutFilterFields: '/report/getReportEditLayoutFilterFields',
  checkReportNameExist: '/report/checkReportNameExist',
  getDataAnalysisDetail: '/report/getDataAnalysisDetail',
  /** **************************自定义报表END**************************/

  /** **************************安全管理**************************/
  getRecentlyCompanyPasswordStrategy: '/user/queryCompanySet', // 获取最近登录公司密码策略
  whiteListMember: '/user/queryCompanyIpList', // 白名单成员
  retentionPolicy: '/user/saveCompanySafe', // 设置保存策略
  autoLogout: '/user/saveLinkSetting', //  设置保存自动退出登录
  deleteMember: '/user/delCompanyWhite', // 删除成员
  addIpConnector: '/user/saveCompanyIp', //  添加ip地址
  deleteIpConnector: '/user/delCompanyIp', // 删除ip地址
  addWhiteListMember: '/user/saveCompanyWhite', // 白名单添加人员
  getWhiteListMember: '/user/queryCompanyWhiteList', // 获取白名单列表成员
  getSavaBack: '/user/savaBackg', // 个人设置偏好
  validationIpInterface: '/user/vailCompanyIp', // 验证设置ip
  queryOperationLogList: '/common/queryOperationLogList', // 日志列表
  queryLoginLogList: '/common/queryLoginLogList', // 登录日志
  operationLogExport: '/common/operationLogExport', // 导出日志
  loginLogExport: '/common/loginLogExport', // 导出日志
  /** **************************END**************************/

  /** **************************回收站**************************/
  dealRecyclebinData: '/recyclebin/dealRecyclebinData', // 处理回收站相关数据信息 还原、删除、情况回收站（接口）
  getRecyclebinFields: '/recyclebin/getDataListFields', // 获取回收站字段列表接口
  recyclebinPhysics: '/recyclebin/deleteByPhysics', // 获取回收站字段列表接口
  /** **************************END**************************/

  /** **************************安全管理**************************/
  changePhoneNumber: '/user/modifyPhone', // 修改电话号码接口
  /** **************************END**************************/

  /** **************************应用上传**************************/
  applyCommentRequest: '/applicationCenter/queryApplicationTemplateById', // 应用中心的上传里面的详情的请求
  centralControlParticularsRequest: '/centerApplication/findApplicationById', // 中央控制台的详情请求
  submitApplyAudit: '/applicationCenter/uploadTemplate', // 提交以供审核
  auditRequest: '/centerApplication/editApplication', // 审批状态的请求
  applyCompileSave: '/centerApplication/updateNonsuchApplication', // 应用的编辑保存
  /** **************************END**************************/

  /** **************************应用中心**************************/
  getInquireApplyList: '/applicationCenter/queryTemplateList', // 获取应用中心列表
  getMyUploadApply: '/applicationCenter/queryOwnTemplateList', // 获取我上传的应用的状态
  deleteMyUploadApply: '/applicationCenter/delApplication', // 删除我上传的应用
  queryTemplateMoneyList: '/applicationCenter/queryTemplateMoneyList', // 资金明细
  queryToken: '/user/queryToken', // 获取公共token
  getApplicationCenterList: '/applicationCenter/getApplicationList', // 应用中心列表
  findAllApplyClassify: '/applicationCenter/findAllClassify ', // 获取所有分类
  findApplicationTemplateInfo: '/applicationCenter/findApplicationTemplateInfo ', // 获取上次上传应用信息
  /** **************************END**************************/

  /** **************************应用中心详情**************************/
  applyParticularsRequest: '/applicationCenter/queryApplicationTemplateById', // 应用中心详情的请求
  commentMoreParticularsRequest: '/applicationCenter/queryApplicationCommentById', // 应用中心评论的加载更多
  commentParticularsRequest: '/applicationCenter/savaApplicationComment', // 应用中心详情的评论发送
  installApply: '/applicationCenter/installTemplate', // 应用中心的安装
  queryWhetherInstall: '/applicationCenter/queryWhetherInstall', // 判断当前应用是否已经在当前公司进行安装接口
  applicationAuthInstall: '/applicationCenter/applicationAuthInstall', // 可安装版本设置判断
  applicationCreateOrder: '/applicationCenter/createOrder', // 创建支付订单
  applicationQueryOrderInfo: '/applicationCenter/queryOrderInfo', // 查询支付状态
  applicationPurchased: '/applicationCenter/purchased', // 检查是否需要收费
  checkAuthorizationCodeUserCount: '/applicationCenter/checkAuthorizationCodeUserCount', // 验证授权码
  /** **************************END**************************/

  /** **************************基础模块设置**************************/
  backendAddRolePermissions: '/projectManagementRoleController/save', // 后台协作的新增
  backendEditorRolePermissions: '/projectManagementRoleController/edit', // 后台协作的编辑
  getAllPermissions: '/projectManagementRoleController/queryPriviledge', // 后台协作获取项目管理权限配置数据
  getRoleMembersList: '/projectManagementRoleController/queryList', // 后台协作获取角色列表
  deleteRole: '/projectManagementRoleController/delete', // 后台协作删除角色
  getCooperationParentLabel: '/taskTagController/queryList', // 后台协作的标签管理获取标签分类
  newlyAddedSubclassification: '/taskTagController/save', // 后台协作的标签管理的创建标签和子类标签
  SearchLabelContent: '/projectManagementTag/blurTagList', // 后台协作模糊查询标签目录
  deleteLabel: '/taskTagController/delete', // 后台协作删除子标签/分类标签
  editLabel: '/taskTagController/edit', // 后台协作编辑标签
  changeOrder: '/taskTagController/changeSequence', // 拖拽改变标签顺序
  /** **************************END**************************/
  /** **************************项目管理任务自定义(后台)**************************/
  saveAllLayout: '/projectLayout/saveAllLayout', // 保存布局
  getAllLayout: '/projectLayout/getAllLayout', // 获取布局
  getAllLayoutBack: 'projectLayout/getAllLayoutBack', // 本地化项目布局新接口
  /** **************************END**************************/

  /** ************************** 项目管理工作台设置(后台) by pen **************************/
  queryworkbenchList: '/projectWorkbenchController/queryList', // 获取工作台列表
  addWorkbench: '/projectWorkbenchController/save', // 新增工作台
  // delWorkbench: '/projectWorkbenchController/delete', // 删除工作台
  editWorkbench: '/projectWorkbenchController/edit', // 编辑工作台
  sortWorkbench: '/projectWorkbenchController/sort', // 工作台排序
  editWorkbenchDetail: '/projectWorkbenchController/queryById', // 获取要编辑的工作台详情
  queryWorkFlow: '/projectWorkflow/queryById', // 获取项目工作流详情
  saveWorkFlow: '/projectWorkflow/save', // 保存项目工作流
  editWorkFlow: '/projectWorkflow/edit', // 编辑项目工作流
  queryWorkFlowList: '/projectWorkflow/queryList', // 获取项目工作流列表
  deleteWrokFlow: '/projectWorkflow/delete', // 删除工作流
  // 20190402
  saveWorkbench: '/workbench/setting/saveWorkbench', // 保存/修改工作台设置
  modifyWorkbench: '/workbench/setting/modifyWorkbench', // 保存/修改工作台设置
  delWorkbench: '/workbench/setting/delWorkbench', // 删除工作台
  getWorkbenchList: '/workbench/setting/getWorkbenchList', // 获取工作台设置列表
  getWorkbenchById: '/workbench/setting/getWorkbenchById', // 获取工作台设置(ID)
  getWorkbenchByName: '/workbench/setting/getWorkbenchByName', // 获取工作台设置(NAME)
  orderByWorkbench: '/workbench/setting/orderByWorkbench', // 工作台设置列表排序接口(NAME)
  getWorkbenchLayoutList: '/workbench/getWorkbenchLayoutList', // 获取当前登录人的工作台列表
  getWorkbenchLayout: '/workbench/getWorkbenchLayout', // 获取工作台布局
  getWorkbenchDataDetail: '/workbench/getWorkbenchDataDetail', // 获取指定的工作台的数据接口
  getWorkbenchDataSingle: '/workbench/getWorkbenchDataSingle', // 用于后台获取单个组件数据用
  getPersonalAndProjectTasks: '/workbench/getPersonalAndProjectTasks1', // 用于后台获取单个组件数据用
  saveSchedule: '/workbench/saveSchedule', // 新增日程
  getScheduleDetail: '/workbench/getScheduleDetail', // 获取日程
  getScheduleDetailNew: '/workbench/getScheduleDetailNew', // 获取日程
  getScheduleDataDetail: '/workbench/getScheduleDataDetail', // 日程详情
  updateScheduleContent: '/workbench/updateScheduleContent', // 修改日程内容
  delSchedule: '/workbench/delSchedule', // 删除日程
  workbenchfindRelationList: '/workbench/findRelationList', // 删除日程
  getOnLineWorkDetail: '/workbench/getOnLineWorkDetail', // 获取在线办公
  saveWorkbenchCalendarShare: '/workbench/setting/saveWorkbenchCalendarShare', // 保存/修改工作台日程共享设置
  getWorkbenchCalendarShareList: '/workbench/setting/getWorkbenchCalendarShareList', // 获取工作台日程共享设置列表
  delWorkbenchCalendarShare: '/workbench/setting/delWorkbenchCalendarShare', // 删除工作台日程共享设置
  getWorkbenchCalendarShareFromUsers: '/workbench/getWorkbenchCalendarShareFromUsers', // 获取日程数据共享者用户
  getCardTaskDepartmentUsers: 'workbench/getCardTaskDepartmentUsers', // 获取可见部门人员
  /** **************************END**************************/

  /** ************************** 中央控制台 **************************/
  queryCenterUserList: '/centerUser/queryUserList', // 获取用户
  centerQueryFchBtnAuth: '/centerRole/queryFchBtnAuth', // 获取权限

  savaFormalUser: '/center/savaFormalUser', // 保存试用客户
  editFormalCompanyUser: '/center/editFormalCompanyUser', // 编辑试用客户
  queryRegisterUserById: '/center/queryRegisterUserById', // 获取客户信息
  queryFormalUserList: '/center/queryFormalUserList', // 获取试用客户列表
  disableFormalCompanyUser: '/center/disableFormalCompanyUser', // 禁用的确定按钮
  enableFormalCompanyUser: '/center/enableFormalCompanyUser', // 启用的确定按钮
  delFormalCompanyUser: '/center/delFormalCompanyUser', // 删除试用客户
  queryRegisterUserList: '/center/queryRegisterUserList', // 获取试用用户
  centerAdoptAccount: '/center/adoptAccount', // 审批
  centerPullBlacklist: '/center/pullBlacklist', // 拉入黑名单
  centerDelCompanyUser: '/center/delCompanyUser', // 删除客户
  centerQueryInviteList: '/center/queryInviteList', // 邀请码列表
  centerSavaInvite: '/center/savaInvite', // 生成邀请码
  centerDelInviteCode: '/center/delInviteCode', // 删除邀请码
  // delFormalCompanyUser2: '/center/delFormalCompanyUser', // 删除试用客户
  // delFormalCompanyUser2: '/center/delFormalCompanyUser', // 删除试用客户
  delFormalCompanyUser2: '/center/delFormalCompanyUser', // 删除试用客户
  /** **************************END**************************/
  /** 项目统计分析 by pen ******************** */
  queryProjectStatistical: '/projectController/queryProjectStatistical', // 项目进度分析
  queryProjectsForStatistical: '/projectController/queryProjectsForStatistical', // 项目列表
  queryProjectsDetailForStatistical: '/projectController/queryProjectsDetailForStatistical', // 项目列表详情
  queryTaskAnalysis: '/projectTaskController/queryTaskAnalysis', // 获取任务分析
  /** end */
  /** 工作台后台 */
  getChartListByModule: '/workbenchOperation/getChartListByModule', // 获取模块下的图表
  getChartLayoutByModuleId: '/workbenchOperation/getChartLayoutByModuleId', // 获取图表详情

  /** end */
  /** web表单后台 */
  saveWebformLayout: '/webform/saveWebformLayout', // 保存web表单布局
  getWebformLayout: '/webform/getWebformLayout', // 获取web表单布局
  getWebformList: '/webform/getWebformList', // 获取表单列表
  deleteWebformLayout: '/webform/deleteWebformLayout', // 删除表单
  openWebformLayout: '/webform/openWebformLayout', // 发布表单
  closeWebformLayout: '/webform/closeWebformLayout', // 关闭表单
  getWebFromTitleCount: '/webform/getWebFromTitleCount', // 关闭表单
  /** end */
  /** 数据分析 *************************************************************************************************/
  daGetModuleList: '/dataAnalysis/getModuleList', // 获取模块列表
  getSourceModules: '/dataAnalysis/getSourceModules', // 获取主数据源
  getSourceFields: '/dataAnalysis/getSourceFields', // 获取主数据源字段
  saveDataAnalysisLayout: '/dataAnalysis/saveDataAnalysisLayout', // 保存数据分析定义
  getSubSourceModules: '/dataAnalysis/getSubSourceModules', // 获取子数据源
  getSubSourceFields: '/dataAnalysis/getSubSourceFields', // 获取子数据源字段
  daGetDataAnalysisDetail: '/dataAnalysis/getDataAnalysisDetail', // 获取数据分析数据详情
  delDataAnalysis: '/dataAnalysis/delDataAnalysis', // 删除数据分析
  getDataAnalysisLayout: '/dataAnalysis/getDataAnalysisLayout', // 获取数据分析定义布局
  getDataAnalysisFilterFields: '/dataAnalysis/getDataAnalysisFilterFields', // 获取高级筛选字段
  getDataAnalysisLeftMenuList: '/dataAnalysis/getDataAnalysisLeftMenuList', // 获取数据分析列表
  cacheDataAnalysisChart: '/dataAnalysis/cacheDataAnalysisChart', // 缓存数据分析图表
  delDataAnalysisChartCache: '/dataAnalysis/delDataAnalysisChartCache', // 缓存单个图表
  getDataAnalysisChartList: '/dataAnalysis/getDataAnalysisChartList', // 获取全局分析的图表列表
  getDataAnalysisChartModuleList: '/dataAnalysis/getDataAnalysisChartModuleList', // 获取全局分析的图表列表
  getDataAnalysisFilterFieldsOverall: 'dataAnalysis/getDataAnalysisFilterFieldsOverall', // 获取全局筛选
  getDataAnalysisDetailSingle: '/dataAnalysis/getDataAnalysisDetailSingle', // 获取单个图表设置
  getDataAnalysisDetailFilter: '/dataAnalysis/getDataAnalysisDetailFilter', // 获取单个图表设置
  getChartLinkageFields: '/dataAnalysis/getChartLinkageFields', // 获取联动字段
  saveDataAnalysisLayoutSingle: '/dataAnalysis/saveDataAnalysisLayoutSingle', // 保存联动设置
  leftMenuSort: '/dataAnalysis/leftMenuSort', // 数据分类列表左菜单排序
  exportPdf: '/dataAnalysis/exportPdf', // 打印PDF
  getDataAnalysisDataList: '/dataAnalysis/getDataAnalysisDataList', // 图表查看数据
  getDataAnalysisDataListFields: '/dataAnalysis/getDataAnalysisDataListFields', // 获取查看数据列表头
  getDataAnalysisChartModuleListMerge: 'dataAnalysis/getDataAnalysisChartModuleListMerge', // 获取联动合并模块列表
  daFindAllModule: '/dataAnalysis/getModuleList', // 获取数据源模块列表
  getReportPageDataList: '/dataAnalysis/getReportPageDataList', // 列表分页
  getDataAnalysisLayoutSingle: '/dataAnalysis/getDataAnalysisLayoutSingle', // 获取单个编辑图表
  getOverallFilterType: 'dataAnalysis/getOverallFilterType', // 检查全局筛选
  dataExportExcel: 'dataAnalysis/exportExcel', // 导出excel
  getDataAnalysisList: '/dataAnalysis/getDataAnalysisList', // 后台获取数据分析列表
  // delDataAnalysis: '/dataAnalysis/delDataAnalysis', // 后台获取数据分析列表
  checkDataAnalysisAuth: '/dataAnalysis/checkDataAnalysisAuth', // 查询数据分析是否有权限

  /** end ******************************************************************************************************************* */
  /** 系统模块设置 */
  findSystemModuleList: '/moduleManagement/findModuleList', // 查找系统模块权限
  updateSystemData: '/moduleManagement/updateData', // 设置系统模块权限
  /** end */

  /** 应用管理-业务配置 */
  findBusinessConfigurationBackupList: 'businessConfiguration/findBusinessConfigurationBackupList', // 获取接单备用人员列表
  getBusinessConfigurationBackupDetail:
    'businessConfiguration/getBusinessConfigurationBackupDetail', // 获取接单备用人员详情
  saveBusinessConfigurationBackup: 'businessConfiguration/saveBusinessConfigurationBackup', // 保存接单备用人员
  updateBusinessConfigurationBackup: 'businessConfiguration/updateBusinessConfigurationBackup', // 编辑接单备用人员
  delBusinessConfigurationBackup: 'businessConfiguration/delBusinessConfigurationBackup', // 删除接单备用人员

  /** 自动化匹配 */
  findIndividuationDetail: 'automatch/findIndividuationDetail', // 获取个性化需求详情
  findIndividuationList: 'automatch/findIndividuationList', // 获取自动化规则列表
  saveIndividuation: 'automatch/saveIndividuation', // 添加个性化需求
  updateIndividuation: 'automatch/updateIndividuation', // 编辑个性化需求
  automatchFindAllModule: 'automatch/findAllModule', // 获取所有自动化模块
  findAutoByBean: 'automatch/findAutoByBean', // 根据bean获取自动匹配列表
  findTabList: 'tab/findTabList', // 获取页签模块列表接口（PC、APP前端调用）
  findListById: 'tab/findListById', // 通过页签获取数据列表接口（PC、APP前端调用）
  /** end */
  findExportList: 'moduleOperation/findExportList', // 获取导出数据接口
  findFilterFieldsNew: 'moduleOperation/findFilterFieldsNew', // 新自定义筛选条件
  getPageInfo: 'moduleOperation/getPageInfo', // 获取模块页码信息接口
  savePageInfo: 'moduleOperation/savePageInfo', // 添加模块页码信息接口
  findReferenceMapping: 'tab/findReferenceMapping', // 获取关联关系映射值接口

  templateFindListFindList: 'layoutField/findList', // 获取常用字段列表
  layoutFieldSave: 'layoutField/save', // 新增布局常用字段
  layoutFieldUpdateAll: 'layoutField/update', // 替换常用字段接口
  templateFindList: 'layoutTemplate/findList', // 布局模板列表接口
  layoutTemplateSave: 'layoutTemplate/save', // 新增布局模板接口
  layoutTemplateDel: 'layoutTemplate/del', // 布局模板删除接口
  layoutTemplateFindDetail: 'layoutTemplate/findDetail', // 布局模板详情接口
  saveModulenew: '/module/saveModule', // 新保存模块接口
  findOptionFieldRelyDetails: '/fieldRelyon/findOptionFieldRelyDetail', // 获取选项字段依赖详情
  getWebformListForAdd: 'webform/getWebformListForAdd', // 获取web表单链接列表
  moduleMove: 'module/move', // 模块移动
  getCustomFunctionList: 'role/getCustomFunctionList', // 获取全局设置的菜单列表
  getCinternalFunctionList: 'role/getCinternalFunctionList', // 获取新建子菜单和审批设置的权限
  getPrivaryFields: 'seapool/getPrivaryFields', // 获取公海池字段列表
  findRuleList: 'seapool/findRuleList', // 获取非公海池规则列表
  findRuleById: 'seapool/findRuleById', // 获取非公海池规则详情
  delRule: 'seapool/delRule', // 删除非公海池规则
  saveRule: 'seapool/saveRule', // 非公海池规则新增和编辑
  submitFindList: 'submit/findList', // 提交校验列表
  submitFindFieldsList: 'submit/findFieldsList', // 布局所有字段
  submitdel: 'submit/del', // 删除提交校验
  submitfindDetail: 'submit/findDetail', // 提交校验详情
  submitsave: 'submit/save', // 提交校验新增

  /** *** 知识库 ******/
  queryRepositoryClassificationList: '/repositoryClassification/queryRepositoryClassificationList', // 获取分类列表
  repositorySave: '/repositoryClassification/save', // 知识库分类保存接口
  repositoryUpdate: '/repositoryClassification/update', // 知识库分类编辑接口
  repositoryDel: '/repositoryClassification/del', // 知识库分类删除接口
  repositorySequencing: '/repositoryClassification/sequencing', // 知识库分类排序接口
  getRepositoryClassificationList: '/repositoryClassification/getRepositoryClassificationList', // 获取知识库分类列表接口（供新增选择用）
  getClassLeftTreeList: '/repositoryClassification/getClassLeftTreeList', // 前端获取分类左树
  queryRepositoryLabelList: '/repositoryLabel/queryRepositoryLabelList', // 知识库标签列表接口
  repositoryLabelSave: '/repositoryLabel/save', // 知识库标签保存接口
  repositoryLabelUpdate: '/repositoryLabel/update', // 知识库标签编辑接口
  repositoryLabelSequencing: '/repositoryLabel/sequencing', // 知识库标签排序接口
  repositoryLabelDel: '/repositoryLabel/del', // 知识库标签删除接口
  getRepositoryLabelList: '/repositoryLabel/getRepositoryLabelList', // 获取标签列表接口（供新增选择用）
  queryRepositoryLibrariess: '/repositoryLibraries/queryRepositoryLibrariess', // 知识库后台查询接口
  repositoryLibrariesSave: '/repositoryLibraries/save', // 知识库保存接口
  queryRepositoryLibrariesList: '/repositoryLibraries/queryRepositoryLibrariesList', // 获取知识列表接口
  getRepositoryLibrariesDetail: '/repositoryLibraries/getDataDetail', // 获取知识库详情接口
  repositoryLibrariesUpdate: '/repositoryLibraries/update', // 知识库编辑接口
  repositoryLibrariesDel: '/repositoryLibraries/del', // 知识库删除接口
  repositoryLibrariesLearning: '/repositoryLibraries/updateLearning', // 知识库确认学习接口
  getReadLearningPersons: '/repositoryLibraries/getReadLearningPersons', // 获取阅读与确认学习的人员接口
  repositoryLibrariesPraise: '/repositoryLibraries/updatePraise', // 知识库点赞/取消点赞接口
  getPraisePersons: '/repositoryLibraries/getPraisePersons', // 获取知识库点赞人接口
  repositoryLibrariesCollection: '/repositoryLibraries/updateCollection', // 知识库收藏/取消收藏接口
  getCollectionPersons: '/repositoryLibraries/getCollectionPersons', // 获取知识库收藏人接口
  getRepositoryVersions: '/repositoryLibraries/getRepositoryVersions', // 获取知识库版本接口
  repositoryLibrariesMove: '/repositoryLibraries/updateMove', // 知识库移动接口
  repositoryLibrariesTop: '/repositoryLibraries/topSetting', // 置顶
  getDataDetailByVersionId: '/repositoryLibraries/getDataDetailByVersionId', // 根据版本获取知识库详情跳转接口
  updateInvitePersonsToAnswer: '/repositoryLibraries/updateInvitePersonsToAnswer', // 邀人回答接口
  queryAssociatesByRepositoryId: '/repositoryLibrariesAssociates/queryAssociatesByRepositoryId', // 获取知识关联列表接口
  repositoryAnswerSave: '/repositoryAnswer/save', // 保存回答接口
  repositoryAnswerUpdate: '/repositoryAnswer/update', // 回答修改接口
  repositoryAnswerDel: '/repositoryAnswer/del', // 回答删除接口
  getRepositoryAnswerList: '/repositoryAnswer/getRepositoryAnswerList', // 获取提问回答接口
  updatePlacedAtTheTop: '/repositoryAnswer/updatePlacedAtTheTop', // 答案置顶接口
  queryAssociatesByAnswerId: '/repositoryAnswer/queryAssociatesByAnswerId', // 获取答案关联列表接口
  /** end */
  sortTab: 'tab/sortTab', // 页签排序
  getTeamfaceFlag: 'role/getTeamfaceFlag', // 平台模版权限判断
  findFieldsList: 'automation/findFieldsList', // 获取新建与更新事件的字段
  getSubform: 'automation/getSubform', // 获取子表单字段
  getRefCorrespondingFields: 'layout/getRefCorrespondingFields', // 获取关联映射的所有对应字段
  getRefMappingFields: 'layout/getRefMappingFields', // 获取关联映射的所有映射字段
  findBatchUpdateFields: 'moduleOperation/findBatchUpdateFields', // 自定义批量修改字段
  batchUpdate: 'moduleOperation/batchUpdate', // 自定义批量修改新增
  getFieldSearching: 'layout/getFieldSearching', // 获取消息推送自定义指定字段
  getLinkageData: 'aggregationLinkage/getLinkageData', // 新数据联动接口
  getLinkageBatchData: 'aggregationLinkage/getLinkageBatchData', // 新数据联动接口(批量)
  copyModule: 'module/copyModule', // 模块复制
  findSubformMappingFieldsList: 'fieldRelyon/findSubformMappingFieldsList', // 子表选项映射字段列表接口
  findSubformMappingList: 'fieldRelyon/findSubformMappingList', // 子表选项映射列表(后台)
  delSubformMapping: 'fieldRelyon/delSubformMapping', // 删除子表选项映射接口
  saveSubformMapping: 'fieldRelyon/saveSubformMapping', // 子表选项映射(新增(编辑))
  findSubRelationDataList: 'fieldRelyon/findSubRelationDataList', // 获取子表关联映射列表接口（前端）
  findReferenceFormulaFields: 'layout/findReferenceFormulaFields', // 获取引用公式的字段列表接口
  // queryTaskInfoByIds: 'projectTaskController/queryTaskInfoByIds', // 关联引用中，获取任务列表信息
  queryTaskInfoByIds: 'standalonetask/queryTaskInfoByIds', // 关联引用中，获取任务列表信息
  resetAssignee: 'workflow/resetAssignee', //  基础模块审批，批量修改审批人
  getFieldTypeList: 'role/getFieldTypeList', // 自定义布局基础字段（新）

  /** 新协作改版接口  start */
  saveNode: 'projectNodeController/saveNode', // 新增分类
  updateNode: 'projectNodeController/updateNode', // 编辑分类
  deleteNode: 'projectNodeController/deleteNode', // 删除分类
  copyNode: 'projectNodeController/copyNode', // 复制分类
  moveNode: 'projectNodeController/moveNode', // 移动分类
  enableOrDisableMileage: 'projectNodeController/enableOrDisableMileage', // 设置/取消里程碑
  saveTask: 'projectTaskController/saveTask', // 新增任务
  updateTaskNew: 'projectTaskController/updateTask', // 编辑任务
  sortNode: 'projectNodeController/sortNode', // 对节点进行排序
  batchSaveNode: 'projectNodeController/batchSaveNode', // 批量创建分类
  moveTaskNew: 'projectTaskController/moveTask', // 新版移动任务
  queryTaskByParentNodeCode: 'projectTaskController/queryTaskByParentNodeCode', // 获取分类下面的任务
  /** 新协作改版接口  end */

  // 列子段宽度拖动调整接口
  saveFieldWidth: 'submenu/saveFieldWidth',
  findModulesList: 'applicationCenter/findModulesList ', // 应用汇中心预览，获取应用列表接口
  previewApplication: 'applicationCenter/previewApplication', // 最新应用汇总新预览获取，布局和列子段接口
  queryTaskDynamicList: 'projectTaskController/queryTaskDynamicList', // 最新查看动态评论状态全部接口
  getApprovalModules: 'approval/getApprovalModules', // 获取新建审批的最新接口
  transferCreator: 'dataAnalysis/transferCreator', // 转移负责人
  queryPersonelTaskList: 'projectTaskController/queryPersonelTaskList', // 查询个人任务
  queryProjectTaskList: 'projectTaskController/queryProjectTaskList', // 查询项目任务
  saveGroup: 'projectController/saveGroup', // 新增项目分组
  queryProjectGroupList: 'projectController/queryProjectGroupList', // 查询项目分组
  deleteGroup: 'projectController/deleteGroup', // 删除项目分组
  saveProjectFields: 'projectController/saveProjectFields', // 保存项目列表设置
  getProjectFields: 'projectController/getProjectFields', // 查询项目列表
  removeLabels: 'projectSettingController/removeLabels', // 最新删除项目标签
  updateTableColumn: 'layout/updateTableColumn', // 布局保存同步字段接口
  resume_field: 'layoutResume/resumeField', // 简历解析
  batch_upload: 'layoutResume/batchUpload', // 批量上传简历解析
  batch_pasre: 'layoutResume/batchPasre', // 批量解析简历
  single_resume_upload: 'layoutResume/singleResumeUpload', // 单个简历解析
  checkAttendanceRelevanceTime: 'approval/checkAttendanceRelevanceTime', // 关联审批单的审批
  queryEmailFieldData: 'module/queryEmailFieldData', // 获取邮件推送字段

  // 短信模版功能
  shortMessageFindAllList: 'short/message/template/findAllList', // 查看所有模板信息
  shortMessageDetail: 'short/message/template/detail', // 查看模板详细
  shortMessageSave: 'short/message/template/save', // 保存或者更新模板
  shortMessageDelete: 'short/message/template/delete', // 删除模板
  autographFindAllList: 'short/message/autograph/findAllList', // 查询所有签名
  isSignNameExist: 'short/message/autograph/isSignNameExist', // 查看签名是否存在
  autographDetail: 'short/message/autograph/detail', // 签名详细
  autographSave: 'short/message/autograph/save', // 新增签名
  autographDelete: 'short/message/autograph/delete', // 删除签名
  autographList: 'short/message/autograph/list', // 签名记录
  messageTemplateList: 'short/message/template/list', // 短信模板分页查询
  setmealFindAllList: 'short/message/setmeal/findAllList', // 获取短信套餐
  createOrder: 'short/message/pay/createOrder', // 短信支付预创建订单
  messageRecordList: 'short/message/record/list', // 短信记录查询
  messageRecordUsage: 'short/message/record/usage', // 短信使用情况
  messageRecordDetail: 'short/message/record/detail', // 短信记录详细
  messageRecordExport: 'short/message/record/export', // 导出短信记录
  getShortMessageSetting: 'short/message/setting/detail', // 获取短信平台配置详细信息
  shortMessageSettingSave: 'short/message/setting/save', // 短信平台配置保存和更新

  // 薪酬
  queryRelationList: 'salaryRelation/queryRelationList', // 获取关联模块列表
  saveRelation: 'salaryRelation/saveRelation', // 保存关联模块
  deleteRelation: 'salaryRelation/deleteRelation', // 删除关联模块
  queryAllSchemeFixedItemList: 'salaryRelation/queryAllSchemeFixedItemList', // 获取所有方案固定工资

  querySchemeList: 'salaryScheme/querySchemeList', // 获取薪酬列表
  saveScheme: 'salaryScheme/saveScheme', // 保存薪酬方案
  deleteScheme: 'salaryScheme/deleteScheme', // 删除薪酬方案
  querySchemeDetail: 'salaryScheme/querySchemeDetail', // 获取薪酬方案详情
  updateSchemeAdmin: 'salaryScheme/updateSchemeAdmin', // 修改方案管理员
  updateSchemeRule: 'salaryScheme/updateSchemeRule', // 编辑方案规则
  queryAttendanceList: 'salaryScheme/queryAttendanceList', // 获取考勤计薪方案
  saveAllowance: 'salaryScheme/saveAllowance', // 保存津补贴方案
  delAllowance: 'salaryScheme/delAllowance', // 删除津补贴方案
  queryAllowanceList: 'salaryScheme/queryAllowanceList', // 获取津补贴方案列表
  saveAttendance: 'salaryScheme/saveAttendance', // 保存考勤计薪方案
  getAttendanceItem: 'salaryScheme/getAttendanceItem', // 获取考勤请假加班项
  delAttendnace: 'salaryScheme/delAttendnace', // 删除考勤计薪方案
  getSocialInsuranceSetting: 'salarySocialInsurance/getSocialInsuranceSetting', // 社保公积金列表
  saveSocialInsurance: 'salarySocialInsurance/saveSocialInsurance', // 编辑公积金设置
  saveSocialInsuranceScheme: 'salarySocialInsurance/saveSocialInsuranceScheme', // 保存社保公积金
  delSocialInsuranceScheme: 'salarySocialInsurance/delSocialInsuranceScheme', // 删除社保公积金
  querySocialInsuranceTemplateList: 'salarySocialInsurance/querySocialInsuranceTemplateList', // 获取社保公积金初始化值
  updateSocialInsuranceSchemeSchemeUsers:
    'salarySocialInsurance/updateSocialInsuranceSchemeSchemeUsers', // 编辑社保公积金方案成员
  querySalarySocialInsuranceDetail: 'salarySocialInsurance/querySalarySocialInsuranceDetail', // 获取社保公积金方案详情

  // 人员映射和联动
  getRelationFieldsForCustom: 'layout/getRelationFieldsForCustom', // 获取人员联动映射和所有联动字段
  getPersonInfo: 'user/getPersonInfo', // 获取映射和联动的值

  // 薪酬前台接口
  queryPayrollList: 'salaryAccounting/queryPayrollList', // 获取工资单列表
  getPayrollDetail: 'salaryAccounting/getPayrollDetail', // 获取工资单详情
  querySalaryAccountingList: 'salaryAccounting/querySalaryAccountingList', // 获取薪酬核算列表
  queryPersonalTaxSpecialAdditionList: 'salarySocialInsurance/queryPersonalTaxSpecialAdditionList', // 获取个税专项附加
  saveSalaryAccounting: 'salaryAccounting/saveSalaryAccounting', // 保存薪酬核算
  updateSalaryAccountingStatus: 'salaryAccounting/updateSalaryAccountingStatus', // 修改薪酬核算状态
  delSalaryAccounting: 'salaryAccounting/delSalaryAccounting', // 删除薪酬核算
  queryAccountingPersonelList: 'salaryAccounting/queryAccountingPersonelList', // 获取薪酬核算详情
  updateAccountingPersonel: 'salaryAccounting/updateAccountingPersonel', // 编辑薪酬核算信息
  deleteSalaryPer: 'salaryAccountingPersonel/delete', // 删除核算人员
  findALLDeleteList: 'salaryAccountingPersonel/findALLDeleteList', // 查询添加人员
  addPerson: 'salaryAccountingPersonel/addPerson', // 添加核算人员
  savePersonalTaxSpecialAddition: 'salarySocialInsurance/savePersonalTaxSpecialAddition', // 编辑个税专项附加
  delPersonalTaxSpecialAddition: 'salarySocialInsurance/delPersonalTaxSpecialAddition', // 删除个税专项附加
  querySalarySocialInsuranceList: 'salarySocialInsurance/querySalarySocialInsuranceList',
  checkSalaryAccountingDate: 'salaryAccounting/checkSalaryAccountingDate', // 校验核算日期
  synchronization: 'salaryAccounting/synchronization', // 同步最新考情设置和考情
  publishSalaryAccounting: 'salaryAccounting/publishSalaryAccounting',
  individualTaxAccumulationImport: 'salaryAccounting/individualTaxAccumulationImport', // 导入薪资核算编辑
  deleteRemindProject: 'projectTaskRemind/deleteRemind', // 删除项目任务提醒
  deleteRepeatProject: 'projectTaskRepeat/deleteRepeat', // 删除项目重复
  deleteRemindPersonel: 'personelTaskRemind/deleteRemind', // 删除个人任务提醒
  deleteRepeatPersonel: 'personelTaskRepeat/deleteRepeat', // 删除个人任务重复
  saveButton: 'tab/saveButton', // 保存自定义按钮设置
  findListButton: 'tab/findListButton', // 获取自定义按钮设置列表
  findButton4ListPage: 'tab/findButton4ListPage', // 获取列表页面自定义按钮列表
  findButton4DetailPage: 'tab/findButton4DetailPage', // 获取详情页面自定义按钮列表
  findAllModuleByBean: 'module/findAllModuleByBean', // 自定义按钮获取所有模块接口
  saveCustomButton: 'moduleOperation/saveCustomButton', // 列表自定义按钮保存
  getUserTicketToken: 'user/getUserTicketToken', // 获取用户票据token
  findRlationsByBean: 'bizflow/findRlationsByBean', // 业务流程获取关联关系
  saveBizflow: 'bizflow/saveBizflow', // 业务流程保存
  getBizflow: 'bizflow/getBizflow', // 获取业务流程
  getCurrentSections: 'bizflow/getCurrentSections', // 获取当前业务流程详情
  updatePrincipal: 'bizflow/updatePrincipal', // 变更负责人
  dealRelation: 'bizflow/dealRelation', // 处理关联操作
  dealApproval: 'bizflow/dealApproval', // 处理审批
  stopBizflow: 'bizflow/stopBizflow', // 终止业务流程
  restartBizflow: 'bizflow/restartBizflow', // 重启业务流程
  resetBizflow: 'bizflow/resetBizflow', // 重置业务流程
  getAprovalTasks: 'bizflow/getAprovalTasks', // 获取审批信息
  getTaskData: 'bizflow/getTaskData', // 获取当前节点的所有任务数据
  updatePersonnelExec: 'bizflow/updatePersonnelExec', // 变更负责人接口
  getBeanFieldFilter: 'module/getBeanFieldFilter', // 新建更新，匹配条件
  setAdmin: 'application/setAdmin', // 应用管员
  getDataAnalysisListByApplicaion: 'dataAnalysis/getDataAnalysisListByApplicaion', // 获取可引用数据分析列表
  delHomepage: 'application/delHomepage', // 删除应用首页
  getHomepage: 'application/getHomepages', // 获取应用首页
  saveHomepage: 'application/saveHomepage', // 新增编辑应用首页
  getDataAnalysisListByModule: 'dataAnalysis/getDataAnalysisListByModule', // 根据模块bean获取关联数据分析列表(GET)
  refDataAnalysis: 'module/refDataAnalysis', // 保存模块引用数据分析（POST）
  delRefDataAnalysis: 'module/delRefDataAnalysis', // 根据应用id模块删除引用关系(POST)
  getBackFields: 'layout/getBackFields', // 获取回填字段及图文识别类型
  dealGraphicRegn: 'layout/dealGraphicRegn', // 图文识别
  dealPlugField: 'layout/dealPlugField', // 文本智能插件
  queryRiskInfo: 'layout/queryRiskInfo', // 风险信息
  delBizflow: 'bizflow/delBizflow', // 删除业务流程
  getAllResetBizflow: 'bizflow/getAllResetBizflow', // 获取重置记录列表
  getResetBizflow: 'bizflow/getResetBizflow', // 获取重置记录详情
  getTaskData4Reset: 'bizflow/getTaskData4Reset', // 获取当前节点的所有任务数据(重置流程)
  getCurrentStatus: 'bizflow/getCurrentStatus', // 获取当前节点的相关信息
  findAllRefModule: 'module/findAllRefModule', // 转移负责人获取关联关系模块
  saveAppInfoRemark: 'application/saveRemark', // 保存应用首页接口

  /**
   * 支付/续费
   */
  getContractList: 'renew/contract/getInfo', // 获取合同信息
  editContract: 'renew/contract/edit', // 编辑合同信息
  getRenewList: 'renew/getRenewList', // 获取公司的续费记录
  getVersionList: 'renew/getVersionList', // 获取收费策略
  calcpriceContract: 'renew/calcprice', // 计算价格
  createContractOrder: 'renew/createOrder', // 创建订单

  getAllOrganizeSplit: 'user/getAllOrganizeSplit', // 隔离部门设置列表
  saveOrganizeSplit: 'user/saveOrganizeSplit', // 隔离部门设置
  delOrganizeSplit: 'user/delOrganizeSplit', // 删除隔离部门设置
  getOrganizeSplitIndividual: 'user/getOrganizeSplitIndividual', // 获取通讯录隔离个人配置
  saveOrUpdateOrganizeSplitIndividual: 'user/saveOrUpdateOrganizeSplitIndividual', // 编辑通讯录隔离个人配置
  tst: 'module/tst',
  // 查重设置
  saveRepetCheck: 'submit/saveRepetCheck', // 保存查重设置
  findRepetCheckDetail: 'submit/findRepetCheckDetail', // 查询查重详情
  findRepetCheckList: 'submit/findRepetCheckList', // 查询查重列表
  checRepeatkDel: 'submit/del', // 删除查重列表
  // 列表设置
  getDataAnalysisListByCustomSetting: 'dataAnalysis/getDataAnalysisListByCustomSetting', // 获取数据分析列表和数值类型信息
  getCustomListSetting: 'module/getCustomListSetting', // 获取自定义列表设置
  saveCustomListSetting: 'module/saveCustomListSetting', // 保存自定义列表设置
  getDataAnalysisListByCustomData: 'dataAnalysis/getDataAnalysisListByCustomData', // 前台按自定义获取数据分析列表

  // 数据分析和后台审批列表，增加操作日志接口
  reportSaveOperationRecord: 'dataAnalysis/saveOperationRecord', // 数据分析增加操作日
  approvalSaveOperationRecord: 'approval/saveOperationRecord', // 后台审批列表增加操作日
  printjournal: 'common/print', // 打印日志保存
  importModuleTempate: '/common/file/importModuleTempate', // 导入模板
  moduleTemplateDownload: '/common/file/moduleTemplateDownload', // 导入模板
  saveDetailLayout: 'layout/saveDetailLayout', // 保存自定义详情布局
  getDetailLayoutBack: 'layout/getDetailLayoutBack', // 保获取自定义详情布局

  dataembeddingpointSave: 'dataembeddingpoint/save', // 运营埋点保存接口
  findSubDataList: 'moduleOperation/findSubDataList', // 详情数值统计，字表关联高级公式查询数据
  getStartEndTime: 'attendanceRelevanceApprove/findDetailByBean', // 详情数值统计，字表关联高级公式查询数据
  getStartToEndLongTime: 'attendanceHoliday/calcApproveTime', // 获取审批单时长
  savePay: 'pay/save', // 保存支付信息
  queryPay: 'pay/queryPayInfo', // 查询支付信息
  createCustomerOrder: 'teamfacepay/createCustomerOrder', // 自定义创建订单
  getPayInfo: 'moduleOperation/getPayInfo', // 获取收款信息
  getDealFormula: 'submit/dealFormula', // 获取公式的值
  getCheckField: 'submit/checkField', // 新增编辑页面的提交校验
  operateByCustom: 'dataAnalysis/operateByCustom', // 后台仪表盘（复制、删除、移动）
  ownerOrAdmin: 'moduleDataAuth/ownerOrAdmin', // 判断是否是企业所有者或者管理员或者应用管理员
  savePlugFields: 'layout/savePlugFields', // 全局设置保存插件
  getPlugFields: 'layout/getPlugFields', // 全局设置获取插件设置
  getCustomCompanyAiReport: 'miniapp/getCustomCompanyAiReport', // 自定义模块获取公司AI报表
  getCustomPersonelAiReport: 'miniapp/getCustomPersonelAiReport', // 自定义模块获取个人AI报表
  getCustomerAccessUserAi: 'miniapp/getCustomerAccessUserAi', // 自定义获取访客AI分析
  getCustomerAccessUser: 'miniapp/getCustomerAccessUser', // 自定义获取访客行为记录
  approvalPass: 'workflow/pass', // 审批通过
  batchDownload: 'common/file/batchDownload', // 批量下载

  // okr项目接口
  okrSaveData: 'okr/saveData', // 保存目标及关键结果
  okrSaveKRData: 'okr/saveKRData', // 保存关键结果
  okrSaveReplay: 'okr/saveReplay', // 保存复盘
  okrFindODataList: 'okr/findODataList', // 获取目标列表
  okrFindOSDataList: 'okr/findOSDataList', // 目标列表-组织视图
  okrSelectObjectList: 'okr/selectObjectList', // 选择对齐目标列表
  okrGetODataDetail: 'okr/getODataDetail', // 目标详情
  okrSaveTopObject: 'okr/saveTopObject', // 目标置顶,方法
  okrFindDemoList: 'okr/findDemoList', // 案例列表
  okrGetKRDataDetail: 'okr/getKRDataDetail', // KR详情
  okrDelete: 'okr/delete', // 删除,方法
  okrFindKRProgressList: 'okr/findKRProgressList', // KR进展情况列表
  okrFindORDataList: 'okr/findORDataList', // 动态列表
  okrFindOProgressList: 'okr/findOProgressList', // 目标进度列表
  okrFindReplyList: 'okr/findReplyList', // 复盘列表
  updateKeyResults: 'okr/updateKeyResults', // kr排序
  okrSaveObjectProgress: 'okr/saveObjectProgress', // 保存目标进度
  okrSaveKeyResultProgress: 'okr/saveKeyResultProgress', // 保存KR进度
  okrSaveKRProgressRecord: 'okr/saveKRProgressRecord', // 保存KR进展
  okrGetEmployeeNames: 'okr/getEmployeeNames', // 获取员工名称
  okrFindOP4Reply: 'okr/findOP4Reply', // 复盘-KR列表
  getReplyDetail: 'okr/getReplyDetail', // 复盘详情
  okrSaveAttachment: 'okr/saveAttachment', // 复盘详情
  okrFindAttachmentList: 'okr/findAttachmentList', // 复盘详情
  okrAddTask: 'standalonetask/addTask', // okr新建任务
  okrProjectExecutionList: 'standaloneTaskReport/projectExecutionList', // okr项目执行列表
  okrGetTaskDetail: 'standalonetask/getTaskDetail', // 获取okr详情
  okrDeleteTask: 'standalonetask/deleteTask', // 删除okr任务
  okrUpdateTask: 'standalonetask/updateTask', // 修改okr任务
  okrSaveRelation: 'standalonetask/saveRelation', // 保存okr任务关联
  okrDeleteRelationn: 'standalonetask/deleteRelation', // 删除okr任务关联
  okrQueryRelationListyByTaskId: 'standalonetask/queryRelationListyByTaskId', // okr获取关联列表
  okrQueryTaskInfoByIds: 'standalonetask/queryTaskInfoByIds', // 保存okr任务关联
  okrSaveRepeatTask: 'standaloneTaskRepeat/saveData', // okr设置重复任务
  okrUpdateRepeatTask: 'standaloneTaskRepeat/updateData', // 修改okr重复任务
  okrGetTaskRepeatList: 'standaloneTaskRepeat/getTaskRepeat', // 获取重复任务设置
  okrDeleteRepeat: 'standaloneTaskRepeat/deleteRepeat', // 删除重复任务设置
  okrUpdateTaskPicklistStatus: 'standalonetask/updateTaskPicklistStatus', // 修改任务状态
  okrUpdateTaskCollaborator: 'standalonetask/updateTaskCollaborator', // 修改任务协作人
  okrGetAllLayout: 'taskLayoutOperationController/getAllLayout', // okr
  okrTaskAddPraise: 'standalonetask/addPraise', // okr任务点赞
  okrTaskCancelPraise: 'standalonetask/cancelPraise', // okr任务取消点赞
  okrGetPraisePerson: 'standalonetask/getPraisePerson', // okr任务取消点赞
  okrTaskQueryQuoteTask: 'standaloneTaskReport/queryQuoteTask', // 引用组件获取个人任务
  okrQueryCollaboratorList: 'standalonetask/queryCollaboratorList', // 获取任务协作人
  okrQueryBeRelationListyByTaskId: 'standalonetask/queryBeRelationListyByTaskId', // 获取okr任务被关联
  okrQuerySubTaskList: 'standalonetask/querySubTaskList', // 获取okr任务子任务列表
  okrAddTaskRemind: 'standalonetask/addTaskRemind', // 添加okr任务提醒
  okrUpdateTaskRemind: 'standalonetask/updateTaskRemind', // 编辑okr任务提醒
  okrGetTaskRemind: 'standalonetask/selectTaskRemind', // 获取okr任务提醒
  okrQueryTaskDynamicList: 'standalonetask/queryTaskDynamicList', // okr任务动态
  okrDeleteRemind: 'standalonetask/deleteTaskRemind', // 删除任务提醒
  okrGetAllLayoutBack: 'taskLayoutOperationController/getAllLayoutBack', // okr任务布局
  okrTaskCheckTask: 'standalonetask/checkTask', // okr任务校验通过和驳回
  okrSaveAllLayout: 'taskLayoutOperationController/saveAllLayout', // 提交布局
  okrQueryAllStandaloneTask: 'standaloneTaskReport/queryAllStandaloneTaskListByKrIds', // 获取任务
  okrGetOKRCount: 'okr/getOKRCount', // 获取参与人和可见成员权限
  okrGetOKRRate: 'okr/getOKRRate', // 获取OKR设定-率
  okrGetOKRDistribute: 'okr/getOKRDistribute', // 每个人负责的目标数量分布
  okrGetKRDistribute: 'okr/getKRDistribute', // 目标下的KR数量分布
  okrGetOKRRelateList: 'okr/getOKRRelateList', // OKR对齐量
  okrGetKRJobList: 'okr/getKRJobList', // 项目执行分解率
  okrGetOKRNoprogress4Week: 'okr/getOKRNoprogress4Week', // 一周内未更新进度的目标
  okrGetKRNoprogress4Week: 'okr/getKRNoprogress4Week', // 一周内未更新进度的KR
  okrFindOKRDetailList: 'okr/findOKRDetailList', // OKR详情列表
  okrGetOKRNumber: 'okr/getOKRNumber', // OKR概述
  okrGetOKRAVGProgress: 'okr/getOKRAVGProgress', // OKR平均完成度
  okrGetKRScoreDistribute: 'okr/getKRScoreDistribute', // KR评分分布
  okrGetTaskPrivilege: 'standalonetask/getTaskPrivilege', // 任务权限
  okrRemindMessager: 'okr/remindMessager', // okr仪表盘一键提醒
  okrFindKRDataList: 'okr/findKRDataList', // 获取kr列表
  queryStandaloneTaskList: 'standaloneTaskReport/queryStandaloneTaskList', // 获取kr列表
  okrFindKRScoreList: 'okr/findKRScoreList', // KR评分列表,方法:post
  selectNoUpdateProgressNumberList: 'standaloneTaskReport/selectNoUpdateProgressNumberList', // 获取一周未更新任务列表
  selectTaskReport: 'standaloneTaskReport/selectTaskReport', // 获取统计
  selectTaskReportList: 'standaloneTaskReport/selectTaskReportList', // 获取任务列表
  okrQueryQuoteTask: 'standaloneTaskReport/queryQuoteTask',
  okrFindRelatedList: 'okr/findRelatedList', // 获取对齐我的列表
  okrNoUpdateRemind: 'standalonetask/noUpdateRemind', // 一周未更新的任务

  // 绩效考核
  getAssessmentGradeList: 'assessmentGrade/getAssessmentGradeList', // 获取等级列表
  assessmentGradeSave: 'assessmentGrade/saveGrade', // 保存等级设置
  assessmentGradeUpdate: 'assessmentGrade/updateGrade', // 修改等级设置
  assessmentGradeDel: 'assessmentGrade/deleteGrade', // 删除等级设置

  achievementManageList: 'achievementManage/getList', // 获取绩效管理列表接口
  achievementManageLaunch: 'achievementManage/launchAssessment', // 发起考核
  achievementManageDetail: 'achievementManage/getDetail', // 获取绩效管理详情接口
  achievementManageDelete: 'achievementManage/delete', // 删除绩效管理接口（同时将所有人的考核数据删除）
  achievementManageRevoke: 'achievementManage/revoke', // 绩效管理-撤回
  achievementManagePublish: 'achievementManage/publish', // 绩效管理-公布
  achievementManageAssessment: 'achievementManage/launchAssessment', // 绩效管理-公布
  reLaunchAssessment: 'achievementManage/reLaunchAssessment', // 绩效管理-重新发起考核
  achievementManageUrging: 'achievementManage/urgingrater', // 绩效管理-考核-催办评分人
  achievementRestartOutTime: 'achievementManage/restartOutTime', // 绩效管理-超期重启
  achievementUpdateVersionTemplate: 'achievementManage/updateVersionTemplate', // 绩效管理-修改截止时间
  assessmentInfoList: 'assessmentInfo/getList', // 获取考核信息列表接口
  assessmentInfoExport: 'assessmentInfo/export', // 导出考核信息列表
  assessmentInfoDetail: 'assessmentInfo/getDetail', // 获取考核信息详情接口
  assessmentInfoUrging: 'assessmentInfo/urging', // 绩效管理-考核-催办评分人
  assessmentInfoAppeal: 'assessmentInfo/appealAssessment', // 绩效管理-考核-申诉
  assessmentInfoPass: 'assessmentInfo/appealPass', // 绩效管理-申诉流程通过
  assessmentInfoReject: 'assessmentInfo/appealReject', // 绩效管理- 申诉流程驳回
  getAchievementAppealList: 'assessmentInfo/findAppealList', // 绩效申诉列表接口

  assessmentEvaluateList: 'assessmentEvaluate/getList', // 绩效管理-获取评分列表
  assessmentEvaluateUpdate: 'assessmentEvaluate/update', // 绩效管理-考核评价
  assessmentEvaluateNodeId: 'assessmentEvaluate/getDetailByNodeId', // 绩效管理-获取我的绩效详情（节点评分）
  assessmentResetEvaluator: 'assessmentEvaluate/resetEvaluator', // 绩效管理-对指定节点进行评分人更换
  assessmentGoalsData: 'assessmentEvaluate/getGoalsData', // 绩效管理-对指定节点进行评分人更换
  assessmentCompleteData: 'assessmentEvaluate/getCompleteData', // 绩效管理-获取完成值数据列表
  assessmentEvaluateRemind: 'assessmentEvaluate/remind', // 提醒ta
  assessmentEvaluateScoreVal: 'assessmentEvaluate/getScoreVal', // 自动计算
  assessmentEvaluateAdjustNode: 'assessmentEvaluate/adjustNode', // 调整流程

  assessmentImproveList: 'assessmentImprove/getAssessmentImproveList', // 获取绩效改进列表
  assessmentImproveInfo: 'assessmentImprove/getAssessmentImproveInfo', // 获取绩效改进详情
  assessmentImproveSave: 'assessmentImprove/saveImprove', // 保存绩效改进
  assessmentImproveUpdate: 'assessmentImprove/updateImprove', // 编辑绩效改进
  assessmentImproveDel: 'assessmentImprove/deleteImprove', // 删除绩效改进
  assessmentImprovePrivilege: 'assessmentImprove/queryPrivilege', // 新增绩效改进判断权限

  achievementTemplateList: 'achievementTemplate/getList', // 获取绩效模板列表
  achievementTemplateDetail: 'achievementTemplate/getDetail', // 获取绩效模板详情
  achievementTemplateSave: 'achievementTemplate/save', // 新增绩效模板接口
  achievementTemplateUpdate: 'achievementTemplate/update', // 编辑绩效模板
  achievementTemplateDelete: 'achievementTemplate/delete', // 删除绩效模板
  achievementTemplateState: 'achievementTemplate/enableDisable', // 启用/停用绩效模板
  achievementTemplateLaunch: 'achievementTemplate/launchAssessment', // 发起考核（绩效模板）
  achievementRefTemplateSaveType: 'achievementRefTemplate/saveTemplateType', // 保存考核模板分类
  achievementRefTemplateTypeList: 'achievementRefTemplate/selectTemplateTypeList', // 获取考核模板分类
  achievementRefTemplateSave: 'achievementRefTemplate/saveTemplate', // 保存考核模板
  achievementRefTemplateDel: 'achievementRefTemplate/deleteTemplate', // 删除考核模板
  achievementRefTemplateList: 'achievementRefTemplate/selectTemplateList', // 获取考核模板列表
  achievementRefTemplateDetail: 'achievementRefTemplate/getDetail', // 获取考核模板详情

  achievementSaveTagretType: 'achievementTemplate/saveTagretType', // 保存指标分类
  achievementSaveTagretLib: 'achievementTemplate/saveTagretLib', // 保存指标
  achievementTargetTypes: 'achievementTemplate/getTargetTypes', // 获取指标分类列表
  achievementTagretLib: 'achievementTemplate/findTagretLib', // 获取指标库列表

  achievementSaveIndustry: 'achievementTemplate/saveIndustry', // 保存行业
  achievementSaveStation: 'achievementTemplate/saveStation', // 保存部门岗位
  achievementSaveTargetTemplate: 'achievementTemplate/saveTtargetTemplate', // 保存系统指标
  achievementSortIndustry: 'achievementTemplate/sortIndustry', // 行业排序
  achievementSortStation: 'achievementTemplate/sortStation', // 部门岗位排序
  achievementSortTargetTemplate: 'achievementTemplate/sortTargetTemplate', // 指标模版排序
  achievementIndustry: 'achievementTemplate/findIndustry', // 行业列表
  achievementStation: 'achievementTemplate/findStation', // 部门岗位列表
  achievementTargetTemplate: 'achievementTemplate/findTargetTemplate', // 指标模版列表

  saveAchievsysTemplateType: 'achievementTemplate/saveAchievsysTemplateType', // 系统考核模板-保存分类
  getAchievsysTemplateTypes: 'achievementTemplate/getAchievsysTemplateTypes', // 系统考核模板-分类列表
  sortAchievsysTemplateType: 'achievementTemplate/sortAchievsysTemplateType', // 系统考核模板-分类排序
  saveAchievsysTemplate: 'achievementTemplate/saveAchievsysTemplate', // 系统考核模板 保存
  sortAchievsysTemplate: 'achievementTemplate/sortAchievsysTemplate', // 系统考核模板排序
  findAchievsysTemplate: 'achievementTemplate/findAchievsysTemplate', // 系统考核模板列表

  getAssessmentInfoList: 'assessmentReport/getAssessmentInfoList', // 获取绩效考核列表
  getAppraiseeNumberGroupByGrade: 'assessmentReport/getAppraiseeNumberGroupByGrade', // 按照等级分组查询
  getAppraiseeNumberGroupByMonth: 'assessmentReport/getAppraiseeNumberGroupByMonth', // 按照月份分组查询
  getAppraiseeNumberGroupByDepartment: 'assessmentReport/getAppraiseeNumberGroupByDepartment', // 按照部门分组查询
  getAssessmentInfoTop: 'assessmentReport/getAssessmentInfoTop', // 按照排名查询
  getAssessmentOKRList: 'assessmentReport/getOKRList', // 获取OKR考核报表列表
  assessmentReportExport: 'assessmentReport/export', // 报表导出
  saveAchievementAdminSetting: 'achievementAdminSettingController/saveAchievementAdminSetting', // 编辑管理员
  getAchievementAdminSetting: 'achievementAdminSettingController/getAchievementAdminSetting', // 获取绩效管理员

  // 目标管理接口集合
  targetSaveKR: 'objective/saveKR', // 保存和编辑kr
  targetSaveRF: 'objective/saveRF', // 保存和编辑参考目标
  targetAdmin: 'objective/admin', // 判断是否是管理员
  targetGetAdmin: 'objective/getAdmin', // 获取管理员列表
  targetSaveLayout: 'objective/saveLayout', // 保存目标梳理、设置管理员
  targetSave: 'objective/save', // 保存目标
  targetGetLayout: 'objective/getLayout', // 获取目标梳理
  targetFindReferLS: 'objective/findReferLS', // 获取目标的参考目标列表
  targetDelete: 'objective/delete', // 删除
  targetMerge: 'objective/merge', // 合并目标
  targetFindOList4Dep: 'objective/findOList4Dep', // 获取岗位目标列表
  targetFindObjectiveLS: 'objective/findObjectiveLS', // 我的目标
  targetFindSolutionLS: 'objective/findSolutionLS', // 方案列表
  targetSaveSolution: 'objective/saveSolution', // .保存方案/模版
  targetGetSolutionDetail: 'objective/getSolutionDetail', // 获取方案详情/模版
  targetFindPerformanceLS: 'objective/findPerformanceLS', // 绩效列表
  targetSavePerformance: 'objective/savePerformance', // 保存绩效
  targetFindObjective4Role: 'objective/findObjective4Role', // 角色下的目标列表
  targetGetPerformance: 'objective/getPerformance', // 绩效设定详情
  targetFindMyPerformanceLS: 'objective/findMyPerformanceLS', // 我的绩效
  targetFindKRPerformanceLS: 'objective/findKRPerformanceLS', // 我的绩效KR
  targetGetObjectiveKR: 'objective/getObjectiveKR', // 获取目标下的KR
  targetSortObjective: 'objective/sortObjective', // 目标拖动排序
  targetSelectObjectiveLS: 'objective/selectObjectiveLS', // 目标拖动排序
  targetFindRecordLS: 'objective/findRecordLS', // 搜索动态记录
  targetGetPerformanceCount: 'objective/getPerformanceCount', // 获取绩效数
  targetSaveMyPerformancet: 'objective/saveMyPerformance', // 获取绩效数
  targetGetPerformancImprLS: 'objective/findPerformancImprLS', // 绩效改进列表
  targetSavePerformanceType: 'objective/savePerformanceType', // 保存绩效分类
  targetGetPerformanceTypeLS: 'objective/findPerformanceTypeLS', // 绩效改进分类列表
  targetSavePerformanceImpr: 'objective/savePerformanceImpr', // 保存绩效改进
  targetGetPerformanceImpl: 'objective/getPerformanceImpl', // 绩效改进详情
  targetGetLeader: 'objective/getLeader', // 获取上级
  targetGetLayout4S: 'objective/getLayout4S', // 获取目标梳理(分享)
  targetFindOLS4S: 'objective/findOLS4S', // 获取岗位目标(分享)
  targetFindObjecitves4me: 'objective/findObjecitves4me', // 个人所见目标列表
  targetFindRoles: 'objective/findRoles', // 部门负责人可见角色列表
  targetGetLeader4Role: 'objective/getLeader4Role', // 部门负责人可见角色列表
  targetExportPerformance: 'objective/exportPerformance', // 导出个人绩效
  shareDataAnalysis: 'dataAnalysis/shareDataAnalysis', // 分配共享数据分析

  // 华巨臣
  signupSaveData: 'signup/config/saveData', // 保存报名后台设置
  signupDeleteData: 'signup/config/deleteData', // 清除后台设置
  signupGetData: 'signup/config/getData', // 清除后台设置
  signupGetLinkList: 'signup/link/getLinkList', // 获取报名链接
  signupSaveLinkData: 'signup/link/saveLinkData', // 新增编辑报名链接
  signupDeleteLinkData: 'signup/link/deleteLinkData', // 删除报名链接
  signupDisableOrEnable: 'signup/link/disableOrEnable', // 禁用/启用链接
  getSignupWebFromList: 'signup/config/getWebFromList', // 获取系统web表单
  saveSignupCheckData: 'signup/config/saveCheckData', // 保存校验设置
  delSignupCheckData: 'signup/config/deleteCheckData', // 删除校验设置
  getSignupCheckData: 'signup/config/queryAllCheckData', // 获取全部校验设置
  delSignupAllkData: 'signup/config/deleteAllData', // 清除所有后台设置
  manualUpdateShortUrl: 'message/yxuntong/manualUpdateShortUrl', // 批量手动生成短链

  // 短信
  saveYxuntongData: 'short/message/setting/saveYxuntongData', // 保存优讯通账号
  getYxuntongData: 'short/message/setting/getYxuntongData', // 获取优讯通账号
  saveReplysettingData: 'short/message/setting/saveReplysettingData', // 保存回复推送设置
  queryReplySettingList: 'short/message/setting/queryReplySettingList', // 获取回复设置
  deleteReplySettingData: 'short/message/setting/deleteReplySettingData', // 删除回复推送设置
  queryMassRecordList: 'message/yxuntong/queryMassRecordList', // 获取模板群发记录
  saveMassData: 'message/yxuntong/saveMassData', // 新建群发短信
  queryMassRecordDetailList: 'message/yxuntong/queryMassRecordDetailList', // 获取错误日子
  saveShortSendMessage: 'short/message/setting/saveSendMessage', // 保存发送设置
  querySendMessageList: 'short/message/setting/querySendMessageList', // 获取发送设置
  deleteSendMessage: 'short/message/setting/deleteSendMessage', // 删除发送设置

  // 获取华巨臣呼叫中心观众模块信息
  getDataDetailMeta: 'submit/getDataDetailMeta',
  saveMapSetting: 'submit/saveMapSetting', // 保存地图设置
  getMapSetting: 'submit/getMapSetting', // 获取地图设置

  // 新企点OKR接口
  tokrSaveObject: 'tokr/saveObject', // 保存目标
  tokrSaveKR: 'tokr/saveKR', // 保存kr
  tokrGetObjectDetail: 'tokr/getObjectDetail', // 获取目标详情
  tokrGetKRDetail: 'tokr/getKRDetail', // 获取kr详情
  tokrDelete: 'tokr/delete', // 删除
  tokrFindODataList: 'tokr/findODataList', // 目标列表接口
  tokrFindRecordList: 'tokr/findRecordList', // 动态列表
  tokrFindProgressList: 'tokr/findProgressList', // 进度列表接口
  tokrUpdateProgress: 'tokr/updateProgress', // 保存进度
  tokrGetEmployeeNames: 'tokr/getEmployeeNames', // 获取员工名称
  tokrSetting: 'tokr/setting', // 保存设置
  tokrGetSetting: 'tokr/getSetting', // 保存设置
  tokrUpdateKRs: 'tokr/updateKRs', // 批量更新KR接口
  tokrUpdateOKRTopnum: 'tokr/updateOKRTopnum', // OKR同级排序接口
  updateRealWorkingHours: 'standalonetask/updateRealWorkingHours', // 任务修改实际工时
  queryTaskDimensionDataByKrId: 'standalonetask/queryTaskDimensionDataByKrId', // 通过kr编号获取任务维度数据
  queryTaskRealWorkHoursByKrId: 'standalonetask/queryTaskRealWorkHoursByKrId', // 通过kr编号获取任务实际使用工时
  tokrFindShareOKRList: 'tokr/findOKRList', // 目标列表-分享
  tokrSaveReplay: 'tokr/saveReplay', // 保存复盘
  tokrGetReplyDetail: 'tokr/getReplyDetail', // 获取复盘详情
  tokrFindReplyList: 'tokr/findReplyList', // 获取复盘详情
  queryTaskRealWorkHoursByTaskId: 'standalonetask/queryTaskRealWorkHoursByTaskId', // 通过任务编号获取任务实际使用工时

  getBizDatas: 'applicationCenter/getBizDatas', // 应用预览，获取旧数据

  // 新待办接口
  customSwimlaneChartStatusWaitDealFieldList: 'waitDeal/customSwimlaneChartStatusWaitDealFieldList',
  customSwimlaneChartStatusWaitDealFindDataList:
    'waitDeal/customSwimlaneChartStatusWaitDealFindDataList',
  customSwimlaneChartStatusBeanList: 'waitDeal/customSwimlaneChartStatusBeanList',
  queryWaitDealList: 'waitDeal/queryWaitDealList', // 全部待办
  queryWaitDealTaskList: 'waitDeal/queryTaskList', // 获取任务列表
  queryWaitDealAttendanceList: 'waitDeal/queryAttendanceList', // 获取考勤列表
  queryWaitDealBizflowList: 'waitDeal/queryBizflowWaitList', // 获取业务流程列表
  queryWaitDealApprovalList: 'waitDeal/queryApprovalList', // 获取审批列表
  queryCustomSwimlaneChartStatusWaitDealForBack:
    'waitDeal/queryCustomSwimlaneChartStatusWaitDealForBack', // 待办后台
  deleteCustomSwimlaneChartStatusWaitDealForBack:
    'waitDeal/deleteCustomSwimlaneChartStatusWaitDealForBack', // 删除待办定制应用
  querySendMessageByBean: 'short/message/setting/querySendMessageByBean', // 获取模块是否可以发送短信

  // 组织架构 2022-07-21
  orgGetDisable: 'department/getDisable', // 获取可停用的部门编号
  orgUpdateStatus: 'department/updateStatus', // 停用,启用部门
  orgMergeMove: 'department/mergeMove', // 合并,移动部门
  orgSaveSnapshot: 'department/saveSnapshot', // 生成快照
  orgDelSnapshot: 'department/delSnapshot', // 删除快照
  orgGetSnapshot: 'department/getSnapshot', // 获取快照
  orgQueryAllSnapshot: 'department/queryAllSnapshot', // 快照列表
  orgSaveSetting: 'department/saveSetting', // 保存设置
  orgGetSetting: 'department/getSetting', // 获取设置详情
  orgImport: 'department/import', // 导入组织架构
  orgExportDepartment: 'department/exportDepartment', // 导出组织架构
  orgSaveDepartments: 'department/saveDepartments', // 批量添加部门
  orgUpdateDepartmentShow: 'department/updateDepartmentShow', // 编辑部门显示方式
  orgSaveEntity: 'department/saveEntity', // 保存实体
  orgFindEntitys: 'department/findEntitys', // 实体列表
  orgDelEntity: 'department/delEntity', // 删除实体
  orgDownloadFile: 'department/downloadFile', // 下载导入模版
  orgExportSnapshot: 'department/exportSnapshot', // 导出快照

  saveDutiesType: 'department/saveDutiesType', // 保存职务分类
  delDutiesType: 'department/delDutiesType', // 删除职务分类
  findDutiesType: 'department/findDutiesType', // 职务分类列表
  importDutiesType: 'department/importDutiesType', // 导入职务分类
  exportDutiesType: 'department/exportDutiesType', // 导出职务分类
  sortDutiesType: 'department/sortDutiesType', // 职务分类排序
  saveDuties: 'department/saveDuties', // 保存职务
  delDuties: 'department/delDuties', // 删除职务
  findDuties: 'department/findDuties', // 职务列表
  importDuties: 'department/importDuties', // 导入职务
  exportDuties: 'department/exportDuties', // 导出职务
  sortDuties: 'department/sortDuties', // 职务排序

  importPost: 'department/importPost', // 导入职位
  exportPost: 'department/exportPost', // 导出职位
  savePost: 'department/savePost', // 保存职位
  delPost: 'department/delPost', // 删除职位
  findPost: 'department/findPost', // 职位列表
  updatePostStatus: 'department/updatePostStatus', // 启用部门
  mergePost: 'department/mergePost', // 合并职位
  saveSequence: 'department/saveSequence', // 保存序列
  delSequence: 'department/delSequence', // 删除序列
  updateSequenceStatus: 'department/updateSequenceStatus', // 修改序列状态
  sortSequence: 'department/sortSequence', // 序列排序
  findSequence: 'department/findSequence', // 序列列表
  savePostLevel: 'department/savePostLevel', // 保存职层
  delPostLevel: 'department/delPostLevel', // 删除职层
  sortPostLevel: 'department/sortPostLevel', // 职层排序
  exportPostLevel: 'department/exportPostLevel', // 导出职层
  importPostLevel: 'department/importPostLevel', // 导入职层
  findPostLevel: 'department/findPostLevel', // 职层列表
  savePostGrade: 'department/savePostGrade', // 保存职级
  delPostGrade: 'department/delPostGrade', // 删除职级
  updatePostGradeStatus: 'department/updatePostGradeStatus', // 修改职级状态
  sortPostGrade: 'department/sortPostGrade', // 职级排序
  findPostGrade: 'department/findPostGrade', // 职级列表
  savePostSystem: 'department/savePostSystem', // 保存职级体系
  updatePostSystemStatus: 'department/updatePostSystemStatus', // 修改体系状态
  findPostSystem: 'department/findPostSystem', // 体系列表
  exportPostSystem: 'department/exportPostSystem', // 导出体系
  saveSalaryGrade: 'department/saveSalaryGrade', // 保存薪级
  findSalaryGrade: 'department/findSalaryGrade', // 薪级列表
  exportSalaryGrade: 'department/exportSalaryGrade', // 导出薪级

  // 导入个税
  importIndividualIncomeTax: 'salaryAccounting/importIndividualIncomeTax',
  getAdAccountList: 'ldapPlugin/findBindAccountList', // 查询AD域已绑定账号列表
  unbindAdAccount: 'ldapPlugin/unbind', // 批量解绑AD域账号
  bindAdAccount: 'ldapPlugin/bind', // 绑定AD域账号
  msal4jsample: 'azure/login', // 获取AD域信息
  saveAllCustomButton: 'moduleOperation/saveAllCustomButton', // 子菜单支持触发自动化规则
  writelog: 'qy/writelog', // 签名日志

  // 2023-07-04 最新文件库优化
  queryTreeFileList: 'fileLibrary/queryTreeFileList', // 获取公司树形文件夹（新）
  queryTreeFilePartList: 'fileLibrary/queryTreeFilePartList', // 获取文件夹下的所有数据（新）
  queryTreeFolderInitDetail: 'fileLibrary/queryTreeFolderInitDetail', // 获取文件夹的详情（新）
  editTreeFolder: 'fileLibrary/editTreeFolder', // 编辑文件夹or批量编辑（新）
  savaTreeFileLibrary: 'fileLibrary/savaTreeFileLibrary', // 新建文件夹（新）
  delBtchFileLibrary: 'fileLibrary/delBtchFileLibrary', // 删除文件夹（新）
  shiftBatchFileLibrary: 'fileLibrary/shiftBatchFileLibrary', // 批量转移文件夹（新）
  queryAppTreeFileList: 'fileLibrary/queryAppTreeFileList', // 获取应用树形文件夹（新）
  viewTreeFolder: 'fileLibrary/viewTreeFolder', // 批量隐藏显示状态（新）
  saveDownLoadRole: 'moduleDataShare/saveDownLoadRole', // 自定义规则下载权限
  delDownLoadRole: 'moduleDataShare/delDownLoadRole', // 删除自定义规则
  getDownLoadRole: 'moduleDataShare/getDownLoadRole', // 获取预览何下载权限
  getDownLoadRoleList: 'moduleDataShare/getDownLoadRoleList', // 查询自定义规则列表
  getDownLoadRoleById: 'moduleDataShare/getDownLoadRoleById', // 文件下载权限详情
  updateIsWatermark: 'fileLibrary/updateIsWatermark', // 水印设置
  queryWatermark: 'fileLibrary/queryWatermark', // 获取水印数据
  getUserByRoleAndDepartment: 'moduleDataAuth/getUserByRoleAndDepartment', // 根据部门id和角色id查员工信息
  blurCompanySearchFile: 'fileLibrary/blurCompanySearchFile', // 公司文件搜索

  ssoGetToken: 'maxkey/sso/getToken', // 通过ssotoken获取token
  queryCommonSignature: 'common/querySignature', // 获取通用签名
  saveNodeSignature: 'assessmentEvaluate/saveNodeSignature', // 保存绩效签名
  isTaskDoingCustom: 'moduleOperation/isTaskDoing', // 判断该条数据是否有自动化任务在执行
  logoutClearToken: '/user/logout', // 退出系统注销清除token

  getMatrixList: '/personnel/matrix/list', // 获取人员矩阵列表
  changeMatrixStatus: '/personnel/matrix/status', // 启用、停用人员矩阵
  queryMatrixReference: '/personnel/matrix/reference', // 人员矩阵引用查询
  delMatrix: '/personnel/matrix/delete', // 删除人员矩阵
  getNextCode: '/personnel/matrix/getNextCode', // 获取新矩阵编码
  addMatrix: '/personnel/matrix/add', // 新增矩阵
  getJobMaintenance: '/personnel/matrix/post/list', // 查询岗位列表
  getPostNextCode: '/personnel/matrix/post/getNextCode', // 获取新岗位编码
  addMatrixPost: '/personnel/matrix/post/add', // 新增岗位
  updateMatrixPost: '/personnel/matrix/post/update', // 修改岗位
  exportMatrixPost: '/personnel/post/export', // 导出岗位列表
  delMatrixPost: '/personnel/matrix/post/delete', // 删除岗位
  getMatrixPostDropDownList: '/personnel/matrix/post/dropDownList', // 获取岗位下拉列表
  getMatrixMappingList: '/personnel/matrix/mapping/list', // 查询映射关系列表
  downLoadMatrixMappingTemplate: '/personnel/matrix/mapping/downLoadTemplate', // 下载映射关系导入模版
  uploadMatrixMappingTemplate: '/personnel/matrix/mapping/importMappingMatrix', // 导入映射关系
  exportMatrixMapping: '/personnel/matrix/mapping/export', // 导出映射关系
  syncSubordinat: '/personnel/matrix/mapping/syncSubordinateMapping', // 同步替换下级
  saveMappingCell: '/personnel/matrix/mapping/save', // 保存单格岗位映射人员
  delMatrixMapping: '/personnel/matrix/deleteMapping', // 删除映射关系
  getMatrixDropDownList: '/personnel/matrix/dropDownList' // 获取矩阵下拉列表
}
export default path
